import React, { useEffect, useContext, useState, useRef } from "react";
import { TokenVerificationLoggedin, BlockAdmin } from "../utils/tokenVerify";
import { LoadingContext } from "react-router-loading";
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../config/config.json";
import { notifysuccess } from "../utils/toast";
import { notifyfailure } from "../utils/toast";
import { notifycatch } from "../utils/toast";
import JSZip from "jszip";
import FileSaver from "file-saver";
import Dropdown from 'react-bootstrap/Dropdown';
import { Table, Tooltip, Radio, Select, Col, Row, Pagination, Input, Button, Checkbox, Modal } from 'antd';
import columnIcon from '../assets/images/icons/column.svg'
import imIcon from '../assets/images/icons/skype.svg';
import crossIcon from '../assets/images/icons/cross.svg';
import telegramIcon from '../assets/images/icons/telegram.svg';
import teamsIcon from '../assets/images/icons/teams_icon_v2.svg';
import wechatIcon from '../assets/images/icons/wechat.svg';
import checkIcon from '../assets/images/icons/check.svg';
import { jwtDecode } from "jwt-decode";
import * as XLSX from "xlsx";
import mediaKitIcon from '../assets/images/icons/download.svg';
import mediaKitIcon2 from '../assets/images/icons/export_download_icon.svg';
import CheckInIcon from '../assets/newlayout/check_in_icon.svg';
import SureIcon from '../assets/newlayout/sure_icon.svg';
import { saveAs } from "file-saver";
import { Link } from 'react-router-dom'
import FullLoader from "../assets/images/full-page-loader.gif"
import prevIcon from '../assets/images/icons/chevron-left.svg';
import nextIcon from '../assets/images/icons/chevron-right.svg';
import noData from '../assets/images/data-graph/no-data.svg';
import importIcon from '../assets/images/icons/import.svg';
import errorData from '../assets/images/data-graph/error-data.svg';
import loaderIcon from "../assets/images/login-and-signup/loader.gif";
import partialDataIcon from '../assets/images/icons/parital_data_icon.svg';
import timeDataIcon from '../assets/images/icons/time_data_icon.svg';

import TableLoader from "./TableLoader";
import PublisherImport from "./PublisherImport";
import PublisherViewEdit from "./PublisherViewEdit";
import MyProfileV2 from "./PublisherProfile/MyProfileV2";

const PublisherListing = () => {
  const loadingContext = useContext(LoadingContext);
  const [apiCall, setApicall] = useState(false)
  const [pageView, setPageView] = useState("table")
  const [archiveModalOpen, setArchiveModalOpen] = useState(false)
  const [archivePendingRecord, setArchivePendingRecord] = useState(null)
  const [publisherViewId, setPublisherViewId] = useState("")
  const [publisherViewName, setPublisherViewName] = useState("")
  const [accountStatus, setAccountStatus] = useState("")
  const [columnPartialData, setColumnPartialData] = useState(false)
  const [columnTimeData, setColumnTimeData] = useState("")

  const [columnPartialDataHuman, setColumnPartialDataHuman] = useState(false)
  const [columnTimeDataHuman, setColumnTimeDataHuman] = useState("")

  const [columnPartialDataDV, setColumnPartialDataDV] = useState(false)
  const [columnTimeDataDV, setColumnTimeDataDV] = useState("")



  const isIndeterminate = (colvis) => {
    const values = Object.values(colvis);
    return values.some(value => value) && !values.every(value => value);
  };

  const [colvisAll, setColvisAll] = useState({
    "Website": false,
    "Email": false,
    "IM": false,
    "Country": false,
    "zone": false,
    "AM": true,
    "Seller Type": true,
    "GAM Integration": true,
    "ADK ID": false,
    "Aniview ID": false,
    "GAM ID": false,
  })

  const [colvisNew, setColvisNew] = useState({
    "Website": false,
    "Email": false,
    "IM": false,
    "Country": false,
    "zone": true,
    "AM": true,
    // "Seller Type": true,
    // "GAM Integration": true,
    // "ADK ID": true,
    // "Aniview ID": true,
    // "GAM ID": true,
  })

  const [colvisOnboarded, setColvisOnboarded] = useState({
    "Website": false,
    "Email": false,
    "IM": false,
    "Country": false,
    "zone": true,
    "AM": true,
    "Seller Type": true,
    "GAM Integration": true,
    // "ADK ID": true,
    // "Aniview ID": true,
    // "GAM ID": true,
  })

  const [colvisRejected, setColvisRejected] = useState({
    "Website": false,
    "Email": false,
    "IM": false,
    "Country": false,
    "zone": true,
    "AM": true,
    "Seller Type": true,
    "GAM Integration": true,
    // "ADK ID": true,
    // "Aniview ID": true,
    // "GAM ID": true,
  })


  const [colvisApproved, setColvisApproved] = useState({
    "Email": true,
    "Website": true,
    "IM": true,
    "Country": false,
    "zone": true,
    "AM": true,
    "Seller Type": true,
    "GAM Integration": true,
    "ADK ID": true,
    "Aniview ID": true,
    "GAM ID": true,

    // "impressions": true,
    // "givtImpressions": true,
    // "sivtImpressions": true,
    "givtSivtImp": true,
    "viewability": true,
    "discrep": true,
    "pix_updatedAt": true,
    // "hs_impressions": true,
    // "hs_givtImpressions": true,
    // "hs_sivtImpressions": true,
    "hs_ivtImpressions": true,
    "hs_discrep": true,
    "human_updatedAt": true,
    "dv_ivtImpressions": true,
    "dv_discrep": true,
    "dv_updatedAt": true
  })

  const [colvisArchive, setColvisArchive] = useState({
    "Website": false,
    "Email": false,
    "IM": false,
    "Country": false,
    "zone": false,
    "AM": true,
    "Seller Type": true,
    "GAM Integration": true,
    "ADK ID": false,
    "Aniview ID": false,
    "GAM ID": false,
  })

  const [colvisDeclined, setColvisDeclined] = useState({
    "Website": false,
    "Email": false,
    "IM": false,
    "Country": false,
    "zone": false,
    "AM": true,
    "Seller Type": true,
    "GAM Integration": true,
    "ADK ID": false,
    "Aniview ID": false,
    "GAM ID": false,
  })

  const [filterRepeaterValueOptions_colvisAll] = useState([
    { label: "Email", value: "Email" },
    { label: "Website", value: "Website" },
    { label: "IM", value: "IM" },
    { label: "Country", value: "Country" },
    { label: "Zones", value: "zone" },
    { label: "AM", value: "AM" },
    { label: "Seller Type", value: "Seller Type" },
    { label: "GAM Integration", value: "GAM Integration" },
    { label: "ADK ID", value: "ADK ID" },
    { label: "Aniview ID", value: "Aniview ID" },
    { label: "GAM ID", value: "GAM ID" },
  ])

  const [filterRepeaterValueOptions_colvisArchive] = useState([
    { label: "Email", value: "Email" },
    { label: "Website", value: "Website" },
    { label: "IM", value: "IM" },
    { label: "Country", value: "Country" },
    { label: "Zones", value: "zone" },
    { label: "AM", value: "AM" },
    { label: "Seller Type", value: "Seller Type" },
    { label: "GAM Integration", value: "GAM Integration" },
    { label: "ADK ID", value: "ADK ID" },
    { label: "Aniview ID", value: "Aniview ID" },
    { label: "GAM ID", value: "GAM ID" },
  ])

  const [filterRepeaterValueOptions_colvisDeclined] = useState([
    { label: "Email", value: "Email" },
    { label: "Website", value: "Website" },
    { label: "IM", value: "IM" },
    { label: "Country", value: "Country" },
    { label: "Zones", value: "zone" },
    { label: "AM", value: "AM" },
    { label: "Seller Type", value: "Seller Type" },
    { label: "GAM Integration", value: "GAM Integration" },
    { label: "ADK ID", value: "ADK ID" },
    { label: "Aniview ID", value: "Aniview ID" },
    { label: "GAM ID", value: "GAM ID" },
  ])

  const [filterRepeaterValueOptions_colvisNew] = useState([
    { label: "Email", value: "Email" },
    { label: "Website", value: "Website" },
    { label: "IM", value: "IM" },
    // { label: "Country", value: "Country" },
    // { label: "Zones", value: "zone" },
    { label: "AM", value: "AM" },
    // { label: "Seller Type", value: "Seller Type" },
    // { label: "GAM Integration", value: "GAM Integration" },
    // { label: "ADK ID", value: "ADK ID" },
    // { label: "Aniview ID", value: "Aniview ID" },
    // { label: "GAM ID", value: "GAM ID" },
  ])

  const [filterRepeaterValueOptions_colvisOnboarded] = useState([
    { label: "Email", value: "Email" },
    { label: "Website", value: "Website" },
    { label: "IM", value: "IM" },
    { label: "Country", value: "Country" },
    // { label: "Zones", value: "zone" },
    { label: "AM", value: "AM" },
    { label: "Seller Type", value: "Seller Type" },
    { label: "GAM Integration", value: "GAM Integration" },
    // { label: "ADK ID", value: "ADK ID" },
    // { label: "Aniview ID", value: "Aniview ID" },
    // { label: "GAM ID", value: "GAM ID" },
  ])

  const [filterRepeaterValueOptions_colvisRejected] = useState([
    { label: "Email", value: "Email" },
    { label: "Website", value: "Website" },
    { label: "IM", value: "IM" },
    { label: "Country", value: "Country" },
    // { label: "Zones", value: "zone" },
    { label: "AM", value: "AM" },
    { label: "Seller Type", value: "Seller Type" },
    { label: "GAM Integration", value: "GAM Integration" },
    // { label: "ADK ID", value: "ADK ID" },
    // { label: "Aniview ID", value: "Aniview ID" },
    // { label: "GAM ID", value: "GAM ID" },
  ])

  const [filterRepeaterValueOptions_colvisApproved] = useState([
    { label: "Email", value: "Email" },
    { label: "Website", value: "Website" },
    { label: "IM", value: "IM" },
    { label: "Country", value: "Country" },
    { label: "Zones", value: "zone" },
    { label: "AM", value: "AM" },
    { label: "Seller Type", value: "Seller Type" },
    { label: "GAM Integration", value: "GAM Integration" },
    { label: "ADK ID", value: "ADK ID" },
    { label: "Aniview ID", value: "Aniview ID" },
    { label: "GAM ID", value: "GAM ID" },
  ])

  // PIXALATE SUNSET: column-visibility options for Pixalate metrics disabled (no API data now).
  // const [filterRepeaterValueOptions_colvis2] = useState([
  //   // { label: "Gross Ad Count", value: "impressions" },
  //   // { label: "GIVT Ad Count", value: "givtImpressions" },
  //   // { label: "SIVT Ad Count", value: "sivtImpressions" },
  //   { label: "IVT", value: "givtSivtImp" },
  //   { label: "Net Viewability", value: "viewability" },
  //   { label: "Discrepancies", value: "discrep" },
  //   { label: "Updated At (PST)", value: "pix_updatedAt" },

  // ])


  const [filterRepeaterValueOptions_colvis3] = useState([
    // { label: "Gross Ad Count", value: "hs_impressions" },
    // { label: "GIVT Ad Count", value: "hs_givtImpressions" },
    // { label: "SIVT Ad Count", value: "hs_sivtImpressions" },
    { label: "IVT", value: "hs_ivtImpressions" },
    // { label: "Net Viewability", value: "viewability" },
    { label: "Discrepancies", value: "hs_discrep" },
    { label: "Updated At (PST)", value: "human_updatedAt" },
  ])

  const [filterRepeaterValueOptions_colvis4] = useState([
    { label: "IVT", value: "dv_ivtImpressions" },
    { label: "Discrepancies", value: "dv_discrep" },
    { label: "Updated At (PST)", value: "dv_updatedAt" },
  ])

  const exportHeader =
    [
      {
        label: "Status",
        key: "Status",
      },
      {
        label: "Name",
        key: "Name",
      },
      {
        label: "Organization Name",
        key: "Organization Name",
      },
      {
        label: "Email",
        key: "Email",
      },
      {
        label: "Website",
        key: "Website",
      },
      {
        label: "IM",
        key: "IM",
      },
      // {
      //   label: "Phone Number",
      //   key: "Phone Number",
      // },
      {
        label: "Country",
        key: "Country",
      },
      {
        label: "Zones",
        key: "zone",
      },
      {
        label: "AM",
        key: "AM",
      },
      {
        label: "Seller Type",
        key: "Seller Type",
      },
      {
        label: "GAM Integration",
        key: "GAM Integration",
      },
      {
        label: "ADK ID",
        key: "ADK ID",
      },
      {
        label: "Aniview ID",
        key: "Aniview ID",
      },
      {
        label: "GAM ID",
        key: "GAM ID",
      },
      // {
      //   label: " Gross Ad Count",
      //   key: "impressions",
      //   group: "Pixalate"
      // },
      // {
      //   label: "GIVT Ad Count",
      //   key: "givtImpressions",
      //   group: "Pixalate"
      // },
      // {
      //   label: "SIVT Ad Count",
      //   key: "sivtImpressions",
      //   group: "Pixalate"
      // },
      // {
      //   label: "IVT",
      //   key: "givtSivtImp",
      //   group: "Pixalate"
      // },
      // {
      //   label: "Net Viewability",
      //   key: "viewability",
      //   group: "Pixalate"
      // },
      // {
      //   label: "Discrepancies",
      //   key: "discrep",
      //   group: "Pixalate"
      // },
      // {
      //   label: "Updated At (UTC)",
      //   key: "pix_updatedAt",
      //   group: "Pixalate"
      // },

      // {
      //   label: "Gross Ad Count",
      //   key: "hs_impressions",
      //   group: "Human"
      // },
      // {
      //   label: "GIVT Ad Count",
      //   key: "hs_givtImpressions",
      //   group: "Human"
      // },
      // {
      //   label: "SIVT Ad Count",
      //   key: "hs_sivtImpressions",
      //   group: "Human"
      // },
      // {
      //   label: "IVT",
      //   key: "hs_ivtImpressions",
      //   group: "Human"
      // },
      // {
      //   label: "Discrepancies",
      //   key: "hs_discrep",
      //   group: "Human"
      // },
      // {
      //   label: "Updated At",
      //   key: "human_updatedAt",
      //   group: "Human"
      // }

    ]

  const [exportLoading, setExportLoading] = useState(false)

  function addCommasToNumber(num) {
    const isDecimal = num % 1 !== 0;
    let numStr = num.toString();
    let [wholePart, decimalPart] = numStr.split(".");
    wholePart = wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (isDecimal) {
      numStr = `${wholePart}.${decimalPart}`;
    } else {
      numStr = wholePart;
    }

    return numStr;
  }

  function utcToPst(value) {
    if (value === null || value === undefined || value === "" || value === "-") return "-";
    const str = String(value).trim();
    if (!str) return "-";
    // Parse "YYYY-MM-DD HH:mm" or any ISO-compatible string as UTC
    const normalized = str.replace(" ", "T") + (str.includes("T") ? "" : ":00Z");
    const date = new Date(normalized);
    if (isNaN(date.getTime())) return "-";
    const opts = { timeZone: "America/Los_Angeles" };
    const datePart = date.toLocaleDateString("en-CA", { ...opts, year: "numeric", month: "2-digit", day: "2-digit" });
    const timePart = date.toLocaleTimeString("en-GB", { ...opts, hour: "2-digit", minute: "2-digit", hour12: false });
    return `${datePart} ${timePart}`;
  }

  //------------------------modal related to checkin ---------------------

  const [isCheckinUserVisible, setIsCheckinUserVisible] = useState(false);
  const [isCheckinUserLoader, setIsCheckinUserLoader] = useState(false);
  const [checkinUser, setCheckinUser] = useState(null);

  const handleCheckIn = (record) => {
    const token = Cookies.get("token_xapads_ssp");
    if (!token) return;

    // setCheckInLoadingId(record._id);
    setIsCheckinUserLoader(true)

    axios
      .post(
        configData.SERVER_URL + "user/directCheckIn",
        { targetUserEmail: record?.Email },
        { headers: { "Content-Type": "application/json", "x-access-token": token } }
      )
      .then((response) => {
        // setTimeout(() => {
        let id = jwtDecode(response.data.data.token)._id;
        let role = jwtDecode(response.data.data.token).role;
        let token = response.data.data.token;

        if ((role === "admin" || role === "u_admin")) {
          axios
            .get(configData.SERVER_URL + "user/status?_id=" + id)
            .then((response) => {
              if (response.data.data.status === "new" || response.data.data.status === "onboard" || response.data.data.status === "rejected" || (response.data.data.status === "declined" && !response.data.data.approveUser)) {
                Cookies.set("token_xapads_ssp", token, { expires: 1 });
                window.open("/onboarding", "_blank")
              } else {
                Cookies.set("token_xapads_ssp", token, { expires: 1 });
                window.open("/dashboard", "_blank")
              }
            })
            .catch((error) => {
              Cookies.set("token_xapads_ssp", token, { expires: 1 });
              window.open("/dashboard", "_blank")
            });
        } else {
          Cookies.set("token_xapads_ssp", token, { expires: 1 });
          window.open("/dashboard", "_blank")
        }
        // }, 1200);

        setIsCheckinUserVisible(false);
        setCheckinUser(null);
        setIsCheckinUserLoader(false)

      })
      .catch((error) => {
        if (error?.response?.data?.message?.length) {
          notifyfailure(error.response.data.message);
        } else {
          notifycatch();
        }
        setIsCheckinUserLoader(false)
      });
  };

  //--------------------------------------------------------------------------

  const columnsAll = [
    {
      title: "Status",
      dataIndex: "Status",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "Status",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      // render: (data) => <div className='badge_content--approved'>{data}</div>,
      fixed: 'left',
      width: 120,
      render: (text, record) => <div className='w_100 position-relative' style={{ pointerEvents: ((text === "New") || (text === "Onboard" && !record?.approveUser)) ? "none" : "auto" }}>
        <Select
          className={`form_select badge_content--${text?.toLowerCase()}`}
          dropdownStyle={{
            width: '14rem'
          }}
          value={text === "New" ? "New" : text?.toLowerCase()}
          // dropdownMatchSelectWidth={false}
          // open={true}

          options={
            text === "New" ?
              [{ label: "Declined", value: "declined" }] :
              text === "Onboard" && record?.onboard_filled ?
                [{ label: "Approved", value: "approved" }, { label: "Onboarded", value: "onboard" }, { label: "Rejected", value: "rejected" }] :
                // text === "Onboard" && !record?.onboard_filled ?
                //   [{ label: "Onboard", value: "onboard" }, { label: "Rejected", value: "rejected" }, { label: "Declined", value: "declined" }] :
                text === "Rejected" && record?.onboard_filled ?
                  [{ label: "Approved", value: "approved" }, { label: "Declined", value: "declined" }, { label: "Rejected", value: "rejected" }] :
                  // text === "Rejected" && !record?.onboard_filled ?
                  //   [{ label: "Rejected", value: "rejected" }, { label: "Declined", value: "declined" }] :
                  // text === "Declined" && !record?.onboard_filled && record?.approvedOnce === false ?
                  //   [{ label: "Declined", value: "declined" }, { label: "New", value: "new" }] :
                  text === "Declined" && record?.onboard_filled && record?.approvedOnce === false ?
                    [{ label: "Approved", value: "approved" }, { label: "Declined", value: "declined" }, { label: "Onboarded", value: "onboard" }] :
                    [{ label: "Approved", value: "approved" }, { label: "Archived", value: "archived" }, { label: "Declined", value: "declined" }]
          }
          onChange={(event) => {

            // if (event.toLowerCase() !== text.toLowerCase()) {

            if (event === "archived") {
              setArchivePendingRecord({ event, record });
              setArchiveModalOpen(true);
              return;
            }

            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
              let token = Cookies.get("token_xapads_ssp");

              let payload = {
                "status": event,
                "_id": record?._id,
                "approvedOnce": record?.approvedOnce
              }


              setLoading(true)
              axios
                .post(configData.SERVER_URL + `ops/statusUpdate`, payload, {
                  headers: {
                    "Content-Type": "application/json",
                    "x-access-token": token,
                  },
                })
                .then((response) => {
                  setApicall(!apiCall)
                  notifysuccess(response.data.message);

                })
                .catch((error) => {
                  if (error.response.data.message?.length !== 0) {
                    notifyfailure(error.response.data.message)
                  }
                  else {
                    notifycatch()
                  }
                  setLoading(false)

                });

            }
            // }
          }
          }
        />
      </div>,

    },


    {
      title: "Name",
      dataIndex: "Name",
      key: "Name",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      fixed: 'left',
      width: 160,
      render: (data, record) => <div className='anchor_text_link_d2'
        onClick={() => {
          setPageView("view");
          setPublisherViewId(record._id)
          setPublisherViewName(record.Name)
          setAccountStatus(record.Status)
        }}

      >{data}</div>,
      // width: 220,
    },
    {
      title: "Organization Name",
      dataIndex: "Organization Name",
      width: 200,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "Organization Name",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,

      render: (data) => <div className='text_dark'>{data}</div>,
    },
    {
      title: "Email",
      dataIndex: "Email",
      key: "Email",
      // width: 250,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisAll["Email"],
      // sortOrder: sort.name === 'Email' ? sort.type : null,
      render: (data) => <Tooltip title={data}><div className='text_dark'>{data}</div></Tooltip>,
    },
    {
      title: "Website",
      dataIndex: "Website",
      width: 200,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "Website",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvisAll["Website"],
      render: (data) => <a href={data.includes("https://") ? data : "https://" + data} target="_blank" className='text_primary' >{data}</a>,
    },
    {
      title: "IM",
      dataIndex: "IM",
      // width: 200,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "IM.value",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisAll["IM"],
      // sorter: true,
      render: (text) => <div className='im_type text_dark'>
        {text?.label === "telegram" ?
          <img src={telegramIcon} alt='USP' /> :
          text?.label === "wechat" ?
            <img src={wechatIcon} alt='USP' /> :
            text?.label === "teams" ?
              <img src={teamsIcon} alt='USP' /> :
              < img src={imIcon} alt='USP' />
        }
        {text?.value}</div>
    },
    // {
    //   title: "Phone Number",
    //   dataIndex: "Phone Number",
    //   width: 170,
    //   key: "Phone Number",
    //   sortDirections: ['ascend', 'descend', 'ascend'],
    //   hidden: !colvisAll["Phone Number"],
    //   // sorter: true,
    //   render: (text) => {
    //     return (<>
    //       {(text === "" || text === undefined || text === null) ? <><div className='text_dark'>-</div></> : <div className='text_dark'>{text}</div>}
    //     </>
    //     )
    //   }

    // },

    {
      title: "Country",
      dataIndex: "Country",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      width: 100,
      key: "Country",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvisAll["Country"],
      render: (text, record) => {
        return (
          <>{
            text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> :
              <Tooltip title={record.countryName}> <div><img src={text} alt={text} className="flag_icon" /></div></Tooltip>
          }
          </>
        )
      },
    },
    {
      title: "Zones",
      dataIndex: "zone",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      width: 80,
      key: "zone",
      hidden: !colvisAll["zone"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      // sorter: true,
      render: (data, record) => <div className='text_dark'>
        {record.Status === "Approved" && data === 0 ?
          <Link className="zero_value_design2" style={{ textDecoration: "none", cursor: "default" }} >{data}</Link> :
          record.Status === "Approved" && data !== 0 ?
            <Link to={`/zoneList?publisher=${record["ADK ID"]}-${record["Name"]}`} target="_blank" className='text_primary back_area_increase_d2'>{data}</Link>
            : <div className='text_dark back_area_increase_d2'>-</div>}
      </div>,
    },
    {
      title: 'AM',
      dataIndex: 'AM',
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "AM",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisAll["AM"],
      // sorter: true,
      // width: 150,
      width: 300,
      render: (text, record) => {
        let selectedAMs = Array.isArray(text) ? text : []
        return (
          <div className={selectedAMs.length === 0 ? "checkbox_value_select_d2 multi_select_tag_d2 am_select_tag_new_design_empty" : "checkbox_value_select_d2 multi_select_tag_d2 am_select_tag_new_design"}>
            <Select
              value={selectedAMs}
              className={selectedAMs.length === 0 ? 'form_select tag_content--add' : "form_select tag_content--badge-grey"}
              dropdownStyle={{
                width: '22rem'
              }}
              mode='multiple'
              // maxTagCount='responsive'
              // placeholder='- Select -'
              popupClassName='diff_select_d2'
              // open={true}
              placement="bottomLeft"
              showSearch={false}
              tagRender={(props) => {
                const { label } = props;

                return (
                  <>
                    {label}
                  </>
                );
              }}
              onChange={(selectedValues) => {
                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {
                  let token = Cookies.get("token_xapads_ssp");
                  let payload = { "am": selectedValues }
                  setLoading(true)
                  axios
                    .post(configData.SERVER_URL + `ops/add_acManager?_id=` + record._id, payload, {
                      headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                      },
                    })
                    .then((response) => {
                      setApicall(!apiCall)
                      notifysuccess(response.data.message);
                    })
                    .catch((error) => {
                      if (error?.response) {
                        if (error?.response?.data?.message?.length !== 0) {
                          notifyfailure(error.response.data.message)
                        }
                      }
                      else {
                        notifycatch()
                      }
                      setLoading(false)
                    });
                }
              }}
            >
              {accountManagerOptions.map(option => (
                <Select.Option key={option.value} value={option.value}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Checkbox
                      checked={selectedAMs.includes(option.value)}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {option.label}
                    </Checkbox>
                  </div>
                </Select.Option>
              ))}
            </Select>
          </div>
        )
      }

    },
    {
      title: "Seller Type",
      dataIndex: "Seller Type",
      width: 133,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "Seller Type",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvisAll["Seller Type"],
      render: (text) => {
        return (
          <>
            {text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> : <div className='tag_content--group'><div className='tag_content--grey'>{text}</div></div>}
          </>
        )
      }

    },
    {
      title: "GAM Integration",
      dataIndex: "GAM Integration",
      width: 120,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "GAM Integration",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisAll["GAM Integration"],
      // sorter: true,
      render: (text) => <div className='text_dark'>{text}</div>,
    },
    // {
    //   title: "Media Kit",
    //   width: 80,
    //   key: "mediaKit",
    //   hidden: !colvisAll["Media Kit"],
    //   render: (_, record) => {
    //     return (
    //       record?.Onboarding === 2 && record["Media Kit"]?.length > 0 ?
    //         <button className='download_icon download_icon_d2'
    //           onClick={() => {
    //             fetchAndDownloadFiles(
    //               record["Media Kit"],
    //               // cell.row.original["title"],
    //               // cell.row.original["trackierCampaignId"]
    //             )

    //           }}
    //         ><img src={mediaKitIcon} alt='USP' /></button>
    //         : <><div className='text_dark'>-</div></>
    //     )
    //   }
    // },
    {
      title: "ADK ID",
      dataIndex: "ADK ID",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      width: 90,
      key: "ADK ID",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvisAll["ADK ID"],
      render: (text) => {
        return (
          <>
            {text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> : <>{text}</>}
          </>
        )
      }
    },
    {
      title: "Aniview ID",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      dataIndex: "Aniview ID",
      width: 230,
      key: "Aniview ID",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisAll["Aniview ID"],
      sorter: true,
      render: (text, record) => {
        return (
          <>
            {(text === "" || text === null || text === undefined) && record.Status === "Approved" ?
              <>
                <div className='text_dark'>
                  {record?.aniviewLoading ?

                    <button className="new_integrate_btn_d2 btn btn_primary loader loader_btn_with_icon">
                      <span> Integrate</span>
                      <img src={FullLoader} alt="USP" className="" />
                    </button>
                    :
                    <button className="new_integrate_btn_d2" onClick={() => { handleAniviewIdCreate(record) }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M7.5 5L10 7.5L7.5 10" stroke="#8952E0" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M2 2V5.5C2 6.03043 2.21071 6.53914 2.58579 6.91421C2.96086 7.28929 3.46957 7.5 4 7.5H10" stroke="#8952E0" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      Integrate
                    </button>
                  }
                </div>
              </>
              :
              (text === "" || text === null || text === undefined) && record.Status !== "Approved" ?
                <><div className='text_dark'>-</div></>
                :
                <>
                  {text}
                </>}
          </>
        )
      }
    },
    {
      title: "GAM ID",
      dataIndex: "GAM ID",
      width: 120,
      key: "GAM ID",
      hidden: !colvisAll["GAM ID"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (text) => {
        return (
          <>
            {text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> : <>{text}</>}
          </>
        )
      }
    },
    {
      title: "Check In",
      key: "checkIn",
      // fixed: 'right',
      width: 80,
      render: (_, record) => (
        <div className='download_icon download_icon_d2'
          onClick={() => {
            setIsCheckinUserVisible(true)
            setCheckinUser(record)
          }
          }

        >
          <Tooltip title="Check In">
            <img src={CheckInIcon} className='img-fluid cursor_pointer' />
          </Tooltip>
        </div >
      ),
    },

  ];

  const columnsDeclined = [
    {
      title: "Status",
      dataIndex: "Status",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "Status",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      fixed: 'left',
      width: 120,
      render: (text, record) => <div className='w_100 position-relative' style={{ pointerEvents: ((text === "New") || (text === "Onboard" && !record?.approveUser)) ? "none" : "auto" }}>
        <Select
          className={`form_select badge_content--${text?.toLowerCase()}`}
          dropdownStyle={{
            width: '14rem'
          }}
          value={text === "New" ? "New" : text?.toLowerCase()}
          options={
            text === "New" ?
              [{ label: "Declined", value: "declined" }] :
              text === "Onboard" && record?.onboard_filled ?
                [{ label: "Approved", value: "approved" }, { label: "Onboarded", value: "onboard" }, { label: "Rejected", value: "rejected" }] :
                text === "Rejected" && record?.onboard_filled ?
                  [{ label: "Approved", value: "approved" }, { label: "Declined", value: "declined" }, { label: "Rejected", value: "rejected" }] :
                  text === "Declined" && record?.onboard_filled && record?.approvedOnce === false ?
                    [{ label: "Approved", value: "approved" }, { label: "Declined", value: "declined" }, { label: "Onboarded", value: "onboard" }] :
                    [{ label: "Approved", value: "approved" }, { label: "Archived", value: "archived" }, { label: "Declined", value: "declined" }]
          }
          onChange={(event) => {
            if (event === "archived") {
              setArchivePendingRecord({ event, record });
              setArchiveModalOpen(true);
              return;
            }
            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
              let token = Cookies.get("token_xapads_ssp");
              let payload = {
                "status": event,
                "_id": record?._id,
                "approvedOnce": record?.approvedOnce
              }
              setLoading(true)
              axios
                .post(configData.SERVER_URL + `ops/statusUpdate`, payload, {
                  headers: {
                    "Content-Type": "application/json",
                    "x-access-token": token,
                  },
                })
                .then((response) => {
                  setApicall(!apiCall)
                  notifysuccess(response.data.message);
                })
                .catch((error) => {
                  if (error.response.data.message?.length !== 0) {
                    notifyfailure(error.response.data.message)
                  }
                  else {
                    notifycatch()
                  }
                  setLoading(false)
                });
            }
          }}
        />
      </div>,
    },
    {
      title: "Name",
      dataIndex: "Name",
      key: "Name",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      fixed: 'left',
      width: 160,
      render: (data, record) => <div className='anchor_text_link_d2'
        onClick={() => {
          setPageView("view");
          setPublisherViewId(record._id)
          setPublisherViewName(record.Name)
          setAccountStatus(record.Status)
        }}
      >{data}</div>,
    },
    {
      title: "Organization Name",
      dataIndex: "Organization Name",
      width: 200,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "Organization Name",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (data) => <div className='text_dark'>{data}</div>,
    },
    {
      title: "Email",
      dataIndex: "Email",
      key: "Email",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisDeclined["Email"],
      render: (data) => <Tooltip title={data}><div className='text_dark'>{data}</div></Tooltip>,
    },
    {
      title: "Website",
      dataIndex: "Website",
      width: 200,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "Website",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvisDeclined["Website"],
      render: (data) => <a href={data.includes("https://") ? data : "https://" + data} target="_blank" className='text_primary' >{data}</a>,
    },
    {
      title: "IM",
      dataIndex: "IM",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "IM.value",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisDeclined["IM"],
      render: (text) => <div className='im_type text_dark'>
        {text?.label === "telegram" ?
          <img src={telegramIcon} alt='USP' /> :
          text?.label === "wechat" ?
            <img src={wechatIcon} alt='USP' /> :
            text?.label === "teams" ?
              <img src={teamsIcon} alt='USP' /> :
              < img src={imIcon} alt='USP' />
        }
        {text?.value}</div>
    },
    {
      title: "Country",
      dataIndex: "Country",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      width: 100,
      key: "Country",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvisDeclined["Country"],
      render: (text, record) => {
        return (
          <>{
            text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> :
              <Tooltip title={record.countryName}> <div><img src={text} alt={text} className="flag_icon" /></div></Tooltip>
          }
          </>
        )
      },
    },
    {
      title: "Zones",
      dataIndex: "zone",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      width: 80,
      key: "zone",
      hidden: !colvisDeclined["zone"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (data, record) => <div className='text_dark'>
        {record.Status === "Approved" && data === 0 ?
          <Link className="zero_value_design2" style={{ textDecoration: "none", cursor: "default" }} >{data}</Link> :
          record.Status === "Approved" && data !== 0 ?
            <Link to={`/zoneList?publisher=${record["ADK ID"]}-${record["Name"]}`} target="_blank" className='text_primary back_area_increase_d2'>{data}</Link>
            : <div className='text_dark back_area_increase_d2'>-</div>}
      </div>,
    },
    {
      title: 'AM',
      dataIndex: 'AM',
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "AM",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisDeclined["AM"],
      width: 300,
      render: (text, record) => {
        let selectedAMs = Array.isArray(text) ? text : []
        return (
          <div className={selectedAMs.length === 0 ? "checkbox_value_select_d2 multi_select_tag_d2 am_select_tag_new_design_empty" : "checkbox_value_select_d2 multi_select_tag_d2 am_select_tag_new_design"}>
            <Select
              value={selectedAMs}
              className={selectedAMs.length === 0 ? 'form_select tag_content--add' : "form_select tag_content--badge-grey"}
              dropdownStyle={{
                width: '22rem'
              }}
              mode='multiple'
              popupClassName='diff_select_d2'
              placement="bottomLeft"
              showSearch={false}
              tagRender={(props) => {
                const { label } = props;
                return (
                  <>
                    {label}
                  </>
                );
              }}
              onChange={(selectedValues) => {
                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {
                  let token = Cookies.get("token_xapads_ssp");
                  let payload = { "am": selectedValues }
                  setLoading(true)
                  axios
                    .post(configData.SERVER_URL + `ops/add_acManager?_id=` + record._id, payload, {
                      headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                      },
                    })
                    .then((response) => {
                      setApicall(!apiCall)
                      notifysuccess(response.data.message);
                    })
                    .catch((error) => {
                      if (error?.response) {
                        if (error?.response?.data?.message?.length !== 0) {
                          notifyfailure(error.response.data.message)
                        }
                      }
                      else {
                        notifycatch()
                      }
                      setLoading(false)
                    });
                }
              }}
            >
              {accountManagerOptions.map(option => (
                <Select.Option key={option.value} value={option.value}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Checkbox
                      checked={selectedAMs.includes(option.value)}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {option.label}
                    </Checkbox>
                  </div>
                </Select.Option>
              ))}
            </Select>
          </div>
        )
      }
    },
    {
      title: "Seller Type",
      dataIndex: "Seller Type",
      width: 133,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "Seller Type",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvisDeclined["Seller Type"],
      render: (text) => {
        return (
          <>
            {text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> : <div className='tag_content--group'><div className='tag_content--grey'>{text}</div></div>}
          </>
        )
      }
    },
    {
      title: "GAM Integration",
      dataIndex: "GAM Integration",
      width: 120,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "GAM Integration",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisDeclined["GAM Integration"],
      render: (text) => <div className='text_dark'>{text}</div>,
    },
    {
      title: "ADK ID",
      dataIndex: "ADK ID",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      width: 90,
      key: "ADK ID",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvisDeclined["ADK ID"],
      render: (text) => {
        return (
          <>
            {text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> : <>{text}</>}
          </>
        )
      }
    },
    {
      title: "Aniview ID",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      dataIndex: "Aniview ID",
      width: 230,
      key: "Aniview ID",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisDeclined["Aniview ID"],
      sorter: true,
      render: (text, record) => {
        return (
          <>
            {(text === "" || text === null || text === undefined) && record.Status === "Approved" ?
              <>
                <div className='text_dark'>
                  {record?.aniviewLoading ?
                    <button className="new_integrate_btn_d2 btn btn_primary loader loader_btn_with_icon">
                      <span> Integrate</span>
                      <img src={FullLoader} alt="USP" className="" />
                    </button>
                    :
                    <button className="new_integrate_btn_d2" onClick={() => { handleAniviewIdCreate(record) }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M7.5 5L10 7.5L7.5 10" stroke="#8952E0" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M2 2V5.5C2 6.03043 2.21071 6.53914 2.58579 6.91421C2.96086 7.28929 3.46957 7.5 4 7.5H10" stroke="#8952E0" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      Integrate
                    </button>
                  }
                </div>
              </>
              :
              (text === "" || text === null || text === undefined) && record.Status !== "Approved" ?
                <><div className='text_dark'>-</div></>
                :
                <>
                  {text}
                </>}
          </>
        )
      }
    },
    {
      title: "GAM ID",
      dataIndex: "GAM ID",
      width: 120,
      key: "GAM ID",
      hidden: !colvisDeclined["GAM ID"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (text) => {
        return (
          <>
            {text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> : <>{text}</>}
          </>
        )
      }
    },
    {
      title: "Check In",
      key: "checkIn",
      width: 80,
      render: (_, record) => (
        <div className='download_icon download_icon_d2'
          onClick={() => {
            setIsCheckinUserVisible(true)
            setCheckinUser(record)
          }}
        >
          <Tooltip title="Check In">
            <img src={CheckInIcon} className='img-fluid cursor_pointer' />
          </Tooltip>
        </div>
      ),
    },
  ];

  const columnsArchive = [
    {
      title: "Status",
      dataIndex: "Status",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "Status",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      fixed: 'left',
      width: 120,
      render: (text, record) => <div className='w_100 position-relative' style={{ pointerEvents: ((text === "New") || (text === "Onboard" && !record?.approveUser)) ? "none" : "auto" }}>
        <Select
          className={`form_select badge_content--${text?.toLowerCase()}`}
          dropdownStyle={{
            width: '14rem'
          }}
          value={text === "New" ? "New" : text?.toLowerCase()}
          options={
            text === "New" ?
              [{ label: "Declined", value: "declined" }] :
              text === "Onboard" && record?.onboard_filled ?
                [{ label: "Approved", value: "approved" }, { label: "Onboarded", value: "onboard" }, { label: "Rejected", value: "rejected" }] :
                text === "Rejected" && record?.onboard_filled ?
                  [{ label: "Approved", value: "approved" }, { label: "Declined", value: "declined" }, { label: "Rejected", value: "rejected" }] :
                  text === "Declined" && record?.onboard_filled && record?.approvedOnce === false ?
                    [{ label: "Approved", value: "approved" }, { label: "Declined", value: "declined" }, { label: "Onboarded", value: "onboard" }] :
                    [{ label: "Approved", value: "approved" }, { label: "Archived", value: "archived" }, { label: "Declined", value: "declined" }]
          }
          onChange={(event) => {
            if (event === "archived") {
              setArchivePendingRecord({ event, record });
              setArchiveModalOpen(true);
              return;
            }
            let status = Cookies.get("token_xapads_ssp") ? true : false;
            if (status) {
              let token = Cookies.get("token_xapads_ssp");
              let payload = {
                "status": event,
                "_id": record?._id,
                "approvedOnce": record?.approvedOnce
              }
              setLoading(true)
              axios
                .post(configData.SERVER_URL + `ops/statusUpdate`, payload, {
                  headers: {
                    "Content-Type": "application/json",
                    "x-access-token": token,
                  },
                })
                .then((response) => {
                  setApicall(!apiCall)
                  notifysuccess(response.data.message);
                })
                .catch((error) => {
                  if (error.response.data.message?.length !== 0) {
                    notifyfailure(error.response.data.message)
                  }
                  else {
                    notifycatch()
                  }
                  setLoading(false)
                });
            }
          }}
        />
      </div>,
    },
    {
      title: "Name",
      dataIndex: "Name",
      key: "Name",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      fixed: 'left',
      width: 160,
      render: (data, record) => <div className='anchor_text_link_d2'
        onClick={() => {
          setPageView("view");
          setPublisherViewId(record._id)
          setPublisherViewName(record.Name)
          setAccountStatus(record.Status)
        }}
      >{data}</div>,
    },
    {
      title: "Organization Name",
      dataIndex: "Organization Name",
      width: 200,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "Organization Name",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (data) => <div className='text_dark'>{data}</div>,
    },
    {
      title: "Email",
      dataIndex: "Email",
      key: "Email",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisArchive["Email"],
      render: (data) => <Tooltip title={data}><div className='text_dark'>{data}</div></Tooltip>,
    },
    {
      title: "Website",
      dataIndex: "Website",
      width: 200,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "Website",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvisArchive["Website"],
      render: (data) => <a href={data.includes("https://") ? data : "https://" + data} target="_blank" className='text_primary' >{data}</a>,
    },
    {
      title: "IM",
      dataIndex: "IM",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "IM.value",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisArchive["IM"],
      render: (text) => <div className='im_type text_dark'>
        {text?.label === "telegram" ?
          <img src={telegramIcon} alt='USP' /> :
          text?.label === "wechat" ?
            <img src={wechatIcon} alt='USP' /> :
            text?.label === "teams" ?
              <img src={teamsIcon} alt='USP' /> :
              <img src={imIcon} alt='USP' />
        }
        {text?.value}</div>
    },
    {
      title: "Country",
      dataIndex: "Country",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      width: 100,
      key: "Country",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvisArchive["Country"],
      render: (text, record) => {
        return (
          <>{
            text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> :
              <Tooltip title={record.countryName}> <div><img src={text} alt={text} className="flag_icon" /></div></Tooltip>
          }
          </>
        )
      },
    },
    {
      title: "Zones",
      dataIndex: "zone",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      width: 80,
      key: "zone",
      hidden: !colvisArchive["zone"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (data, record) => <div className='text_dark'>
        {record.Status === "Approved" && data === 0 ?
          <Link className="zero_value_design2" style={{ textDecoration: "none", cursor: "default" }} >{data}</Link> :
          record.Status === "Approved" && data !== 0 ?
            <Link to={`/zoneList?publisher=${record["ADK ID"]}-${record["Name"]}`} target="_blank" className='text_primary back_area_increase_d2'>{data}</Link>
            : <div className='text_dark back_area_increase_d2'>-</div>}
      </div>,
    },
    {
      title: 'AM',
      dataIndex: 'AM',
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "AM",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisArchive["AM"],
      width: 300,
      render: (text, record) => {
        let selectedAMs = Array.isArray(text) ? text : []
        return (
          <div className={selectedAMs.length === 0 ? "checkbox_value_select_d2 multi_select_tag_d2 am_select_tag_new_design_empty" : "checkbox_value_select_d2 multi_select_tag_d2 am_select_tag_new_design"}>
            <Select
              value={selectedAMs}
              className={selectedAMs.length === 0 ? 'form_select tag_content--add' : "form_select tag_content--badge-grey"}
              dropdownStyle={{
                width: '22rem'
              }}
              mode='multiple'
              popupClassName='diff_select_d2'
              placement="bottomLeft"
              showSearch={false}
              tagRender={(props) => {
                const { label } = props;
                return (<>{label}</>);
              }}
              onChange={(selectedValues) => {
                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {
                  let token = Cookies.get("token_xapads_ssp");
                  let payload = { "am": selectedValues }
                  setLoading(true)
                  axios
                    .post(configData.SERVER_URL + `ops/add_acManager?_id=` + record._id, payload, {
                      headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                      },
                    })
                    .then((response) => {
                      setApicall(!apiCall)
                      notifysuccess(response.data.message);
                    })
                    .catch((error) => {
                      if (error?.response) {
                        if (error?.response?.data?.message?.length !== 0) {
                          notifyfailure(error.response.data.message)
                        }
                      }
                      else {
                        notifycatch()
                      }
                      setLoading(false)
                    });
                }
              }}
            >
              {accountManagerOptions.map(option => (
                <Select.Option key={option.value} value={option.value}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Checkbox
                      checked={selectedAMs.includes(option.value)}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {option.label}
                    </Checkbox>
                  </div>
                </Select.Option>
              ))}
            </Select>
          </div>
        )
      }
    },
    {
      title: "Seller Type",
      dataIndex: "Seller Type",
      width: 133,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "Seller Type",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvisArchive["Seller Type"],
      render: (text) => {
        return (
          <>
            {text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> : <div className='tag_content--group'><div className='tag_content--grey'>{text}</div></div>}
          </>
        )
      }
    },
    {
      title: "GAM Integration",
      dataIndex: "GAM Integration",
      width: 120,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "GAM Integration",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisArchive["GAM Integration"],
      render: (text) => <div className='text_dark'>{text}</div>,
    },
    {
      title: "ADK ID",
      dataIndex: "ADK ID",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      width: 90,
      key: "ADK ID",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      hidden: !colvisArchive["ADK ID"],
      render: (text) => {
        return (
          <>
            {text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> : <>{text}</>}
          </>
        )
      }
    },
    {
      title: "Aniview ID",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      dataIndex: "Aniview ID",
      width: 230,
      key: "Aniview ID",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisArchive["Aniview ID"],
      sorter: true,
      render: (text) => {
        return (
          <>
            {(text === "" || text === null || text === undefined) ? <><div className='text_dark'>-</div></> : <>{text}</>}
          </>
        )
      }
    },
    {
      title: "GAM ID",
      dataIndex: "GAM ID",
      width: 120,
      key: "GAM ID",
      hidden: !colvisArchive["GAM ID"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (text) => {
        return (
          <>
            {text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> : <>{text}</>}
          </>
        )
      }
    },
    {
      title: "Check In",
      key: "checkIn",
      // fixed: 'right',
      width: 80,
      render: (_, record) => (
        <div className='download_icon download_icon_d2'
          onClick={() => {
            setIsCheckinUserVisible(true)
            setCheckinUser(record)
          }
          }

        >
          <Tooltip title="Check In">
            <img src={CheckInIcon} className='img-fluid cursor_pointer' />
          </Tooltip>
        </div >
      ),
    },
  ];

  const columnsNew = [
    // {
    //   title: "Action",
    //   key: "action",
    //   // render: (data) => <div className='badge_content--approved'>{data}</div>,
    //   fixed: 'left',
    //   width: 120,
    //   render: (_, record) => <div className='btn_group'>
    //     {/* <button className='btn_outline_success btn' onClick={() => { statusChange("approved", record._id, record.approvedOnce) }}><img src={checkIcon} alt='USP' /> Verify</button> */}
    //     <button className='btn_outline_danger btn' onClick={() => { statusChange("declined", record._id, record.approvedOnce) }}><img src={crossIcon} alt='USP' /> Decline</button>
    //     {/* <button className='btn_outline_danger btn' onClick={() => { statusChange("rejected", record._id, record.approvedOnce) }}><img src={crossIcon} alt='USP' /> Reject</button> */}
    //   </div>,

    // },
    {
      title: "Name",
      dataIndex: "Name",
      key: "Name",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      fixed: 'left',
      width: 200,
      render: (data, record) => <div className='anchor_text_link_d2'
        onClick={() => {
          setPageView("view");
          setPublisherViewId(record._id)
          setPublisherViewName(record.Name)
          setAccountStatus(record.Status)
        }}

      >{data}</div>,
      // width: 220,
    },
    {
      title: "Organization Name",
      dataIndex: "Organization Name",
      width: 200,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "Organization Name",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (data) => <div className='text_dark'>{data}</div>,
    },
    {
      title: "Email",
      dataIndex: "Email",
      key: "Email",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      // width: 200,
      sorter: true,
      hidden: !colvisNew["Email"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      // sortOrder: sort.name === 'Email' ? sort.type : null,
      render: (data) => <Tooltip title={data}><div className='text_dark'>{data}</div></Tooltip>,
    },
    {
      title: "Website",
      dataIndex: "Website",
      // width: 200,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "Website",
      hidden: !colvisNew["Website"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (data) => <a href={data.includes("https://") ? data : "https://" + data} target="_blank" className='text_primary' >{data}</a>,
    },
    {
      title: "IM",
      dataIndex: "IM",
      // width: 200,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "IM.value",
      hidden: !colvisNew["IM"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      // sorter: true,
      render: (text) => <div className='im_type text_dark'>
        {text?.label === "telegram" ?
          <img src={telegramIcon} alt='USP' /> :
          text?.label === "wechat" ?
            <img src={wechatIcon} alt='USP' /> :
            <img src={imIcon} alt='USP' />
        }
        {text?.value}</div>
    },
    {
      title: 'AM',
      dataIndex: 'AM',
      key: "AM",
      hidden: !colvisNew["AM"],
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      sortDirections: ['ascend', 'descend', 'ascend'],
      // sorter: true,
      width: 300,
      render: (text, record) => {
        let selectedAMs = Array.isArray(text) ? text : []
        return (
          <div className={selectedAMs.length === 0 ? "checkbox_value_select_d2 multi_select_tag_d2 am_select_tag_new_design_empty" : "checkbox_value_select_d2 multi_select_tag_d2 am_select_tag_new_design"}>
            <Select
              value={selectedAMs}
              className={selectedAMs.length === 0 ? 'form_select tag_content--add' : "form_select tag_content--badge-grey"}
              dropdownStyle={{
                width: '22rem'
              }}
              mode='multiple'
              // maxTagCount='responsive'
              // placeholder='- Select -'
              placement="bottomLeft"
              popupClassName='diff_select_d2'
              showSearch={false}
              tagRender={(props) => {
                const { label } = props;

                return (
                  <>
                    {label}
                  </>
                );
              }}
              onChange={(selectedValues) => {
                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {
                  let token = Cookies.get("token_xapads_ssp");
                  let payload = { "am": selectedValues }
                  setLoading(true)
                  axios
                    .post(configData.SERVER_URL + `ops/add_acManager?_id=` + record._id, payload, {
                      headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                      },
                    })
                    .then((response) => {
                      setApicall(!apiCall)
                      notifysuccess(response.data.message);
                    })
                    .catch((error) => {
                      if (error?.response) {
                        if (error?.response?.data?.message?.length !== 0) {
                          notifyfailure(error.response.data.message)
                        }
                      }
                      else {
                        notifycatch()
                      }
                      setLoading(false)
                    });
                }
              }}
            >
              {accountManagerOptions.map(option => (
                <Select.Option key={option.value} value={option.value}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Checkbox
                      checked={selectedAMs.includes(option.value)}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {option.label}
                    </Checkbox>
                  </div>
                </Select.Option>
              ))}
            </Select>
          </div>
        )
      }

    },

    // {
    //   title: "Pixalate",
    //   onHeaderCell: () => ({
    //     className: 'diff_border_line_clr',
    //   }),
    //   hidden: !(
    //     colvisAll.impressions ||
    //     colvisAll.givtImpressions ||
    //     colvisAll.sivtImpressions ||
    //     colvisAll.givtSivtImp ||
    //     colvisAll.viewability ||
    //     colvisAll.discrep ||
    //     colvisAll.pix_updatedAt
    //   ),
    //   "children": [

    //     {
    //       title:

    //         <>

    //           <span >
    //             Gross Ad Count
    //             {columnPartialData ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeData})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //               :

    //               <Tooltip
    //                 title={`Complete Data (${columnTimeData})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>


    //         </>,
    //       dataIndex: "impressions",
    //       width: 170,
    //       key: "impressions",
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["impressions"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title:
    //         <>

    //           <span >
    //             GIVT Ad Count
    //             {columnPartialData ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeData})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>

    //               :
    //               <Tooltip
    //                 title={`Complete Data (${columnTimeData})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>


    //         </>,
    //       dataIndex: "givtImpressions",
    //       width: 170,
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       key: "givtImpressions",
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["givtImpressions"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)}  {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.givtImpsRate)}%)</span>}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title:
    //         <>

    //           <span >
    //             SIVT Ad Count
    //             {columnPartialData ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeData})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //               :
    //               <Tooltip
    //                 title={`Complete Data (${columnTimeData})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>


    //         </>,
    //       dataIndex: "sivtImpressions",
    //       width: 170,
    //       key: "sivtImpressions",
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["sivtImpressions"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)}   {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.sivtImpsRate)}%)</span>}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title: <>

    //         <span >
    //           IVT
    //           {columnPartialData ?
    //             <Tooltip
    //               title={`Partial Data (${columnTimeData})`}
    //             >
    //               <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //             </Tooltip>
    //             :
    //             <Tooltip
    //               title={`Complete Data (${columnTimeData})`}
    //             >
    //               <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //             </Tooltip>
    //           }
    //         </span>


    //       </>,
    //       dataIndex: "givtSivtImp",
    //       width: 160,
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       key: "givtSivtImp",
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["givtSivtImp"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)} {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.givtSivtRate)}%)</span>}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title:
    //         <>

    //           <span >
    //             Net Viewability
    //             {columnPartialData ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeData})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //               :
    //               <Tooltip
    //                 title={`Complete Data (${columnTimeData})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>



    //         </>,
    //       dataIndex: "viewability",
    //       width: 150,
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       key: "viewability",
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["viewability"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)} %
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title:
    //         <>

    //           <span >
    //             Discrepancies
    //             {columnPartialData ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeData})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>

    //               :
    //               <Tooltip
    //                 title={`Complete Data (${columnTimeData})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>

    //         </>,
    //       dataIndex: "discrep",
    //       width: 150,
    //       key: "discrep",
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["discrep"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 <span style={{ color: data.split(" ")[0] === "Low" ? "#0C875E" : data.split(" ")[0] === "High" ? "#FF0000" : "#EBB200" }}>{data.split(" ")[0]}</span> <span style={{ color: "#475467" }}>{data.split(" ")[1]}</span>
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title: "Updated At (UTC)",
    //       dataIndex: "pix_updatedAt",
    //       width: 150,
    //       key: "pix_updatedAt",
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["pix_updatedAt"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {data}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },

    //   ]
    // },

    // {
    //   title: "Human",
    //   onHeaderCell: () => ({
    //     className: 'diff_border_line_clr',
    //   }),
    //   hidden: !(
    //     colvisAll.hs_impressions ||
    //     colvisAll.hs_givtImpressions ||
    //     colvisAll.hs_sivtImpressions ||
    //     colvisAll.hs_ivtImpressions ||
    //     // colvisAll.viewability ||
    //     colvisAll.hs_discrep ||
    //     colvisAll.human_updatedAt
    //   ),
    //   "children": [

    //     {
    //       title:

    //         <>

    //           <span >
    //             Gross Ad Count
    //             {columnPartialDataHuman ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeDataHuman})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //               :

    //               <Tooltip
    //                 title={`Complete Data (${columnTimeDataHuman})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>


    //         </>,
    //       dataIndex: "hs_impressions",
    //       width: 170,
    //       key: "hs_impressions",
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["hs_impressions"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title:
    //         <>

    //           <span >
    //             GIVT Ad Count
    //             {columnPartialDataHuman ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeDataHuman})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>

    //               :
    //               <Tooltip
    //                 title={`Complete Data (${columnTimeDataHuman})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>


    //         </>,
    //       dataIndex: "hs_givtImpressions",
    //       width: 170,
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       key: "hs_givtImpressions",
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["hs_givtImpressions"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)}  {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.hs_givtRate)}%)</span>}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title:
    //         <>

    //           <span >
    //             SIVT Ad Count
    //             {columnPartialDataHuman ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeDataHuman})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //               :
    //               <Tooltip
    //                 title={`Complete Data (${columnTimeDataHuman})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>


    //         </>,
    //       dataIndex: "hs_sivtImpressions",
    //       width: 170,
    //       key: "hs_sivtImpressions",
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["hs_sivtImpressions"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)}   {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.hs_sivtRate)}%)</span>}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title: <>

    //         <span >
    //           IVT
    //           {columnPartialDataHuman ?
    //             <Tooltip
    //               title={`Partial Data (${columnTimeDataHuman})`}
    //             >
    //               <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //             </Tooltip>
    //             :
    //             <Tooltip
    //               title={`Complete Data (${columnTimeDataHuman})`}
    //             >
    //               <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //             </Tooltip>
    //           }
    //         </span>


    //       </>,
    //       dataIndex: "hs_ivtImpressions",
    //       width: 160,
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       key: "hs_ivtImpressions",
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["hs_ivtImpressions"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)} {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.hs_ivtRate)}%)</span>}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     // {
    //     //     title:
    //     //         <>

    //     //             <span >
    //     //                 Net Viewability
    //     //                 {columnPartialData ?
    //     //                     <Tooltip
    //     //                         title={`Partial Data (${columnTimeData})`}
    //     //                     >
    //     //                         <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //     //                     </Tooltip>
    //     //                     :
    //     //                     <Tooltip
    //     //                         title={`Complete Data (${columnTimeData})`}
    //     //                     >
    //     //                         <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //     //                     </Tooltip>
    //     //                 }
    //     //             </span>



    //     //         </>,
    //     //     dataIndex: "viewability",
    //     //     width: 150,
    //     //     onHeaderCell: () => ({
    //     //         className: 'border_right_0',
    //     //     }),
    //     //     key: "viewability",
    //     //     sortDirections: ['ascend', 'descend', 'ascend'],
    //     //     sorter: true,
    //     //     hidden: !colvisAll["viewability"],
    //     //     render: (data, record) => {
    //     //         return (
    //     //             <>
    //     //                 {(data === "" || data === undefined || data === null) ?
    //     //                     <>
    //     //                         <div className='text_dark'>-</div>
    //     //                     </>
    //     //                     :
    //     //                     <>
    //     //                         {addCommasToNumber(data)} %
    //     //                     </>
    //     //                 }
    //     //             </>
    //     //         )
    //     //     },
    //     // },
    //     {
    //       title:
    //         <>

    //           <span >
    //             Discrepancies
    //             {columnPartialDataHuman ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeDataHuman})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>

    //               :
    //               <Tooltip
    //                 title={`Complete Data (${columnTimeDataHuman})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>

    //         </>,
    //       dataIndex: "hs_discrep",
    //       width: 150,
    //       key: "hs_discrep",
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["hs_discrep"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 <span style={{ color: data.split(" ")[0] === "Low" ? "#0C875E" : data.split(" ")[0] === "High" ? "#FF0000" : "#EBB200" }}>{data.split(" ")[0]}</span> <span style={{ color: "#475467" }}>{data.split(" ")[1]}</span>
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title: "Updated At (UTC)",
    //       dataIndex: "human_updatedAt",
    //       width: 150,
    //       key: "human_updatedAt",
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["human_updatedAt"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {data}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },

    //   ]
    // }
    {
      title: "Check In",
      key: "checkIn",
      // fixed: 'right',
      width: 80,
      render: (_, record) => (
        <div className='download_icon download_icon_d2'
          onClick={() => {
            setIsCheckinUserVisible(true)
            setCheckinUser(record)
          }
          }

        >
          <Tooltip title="Check In">
            <img src={CheckInIcon} className='img-fluid cursor_pointer' />
          </Tooltip>
        </div >
      ),
    },

  ];

  const columnsOnboard = [
    {
      title: "Action",
      key: "action",
      // render: (data) => <div className='badge_content--approved'>{data}</div>,
      fixed: 'left',
      width: 68,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      render: (_, record) => <div className='btn_group' style={{
        width: '2.6rem'
      }}>
        <Tooltip title="Approve">

          <button className='btn_outline_success btn --diff_clr_of_approved_box' style={{ width: '2.8rem' }} disabled={(!record.onboard_filled || !record.approveUser)} onClick={() => { statusChange("approved", record._id, record.approvedOnce) }}>
            <img src={checkIcon} alt='USP' />
            {/* Approve */}
          </button>
        </Tooltip>
        <Tooltip title="Reject">

          {/* <button className='btn_outline_danger btn' onClick={() => { statusChange("declined", record._id, record.approvedOnce) }}><img src={crossIcon} alt='USP' /> Decline</button> */}
          <button className='btn_outline_danger btn --diff_clr_of_reject_box' style={{ width: '2.8rem' }} disabled={!record.approveUser} onClick={() => { statusChange("rejected", record._id, record.approvedOnce) }}>
            <img src={crossIcon} style={{ filter: 'none' }} alt='USP' />
            {/* Reject */}
          </button>
        </Tooltip>
      </div>,

    },
    {
      title: "Name",
      dataIndex: "Name",
      key: "Name",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      fixed: 'left',
      width: 300,
      render: (data, record) => <div className='anchor_text_link_d2'
        onClick={() => {
          setPageView("view");
          setPublisherViewId(record._id)
          setPublisherViewName(record.Name)
          setAccountStatus(record.Status)
        }}

      >{data}</div>,
      // width: 220,
    },
    {
      title: "Organization Name",
      dataIndex: "Organization Name",
      width: 300,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "Organization Name",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (data) => <div className='text_dark'>{data}</div>,
    },
    {
      title: "Email",
      dataIndex: "Email",
      key: "Email",
      // width: 200,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      sorter: true,
      hidden: !colvisOnboarded["Email"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      // sortOrder: sort.name === 'Email' ? sort.type : null,
      render: (data) => <Tooltip title={data}><div className='text_dark'>{data}</div></Tooltip>,
    },
    {
      title: "Website",
      dataIndex: "Website",
      // width: 200,
      key: "Website",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisOnboarded["Website"],
      sorter: true,
      render: (data) => <a href={data.includes("https://") ? data : "https://" + data} target="_blank" className='text_primary' >{data}</a>,
    },
    {
      title: "IM",
      dataIndex: "IM",
      // width: 200,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "IM.value",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisOnboarded["IM"],
      // sorter: true,
      render: (text) => <div className='im_type text_dark'>
        {text?.label === "telegram" ?
          <img src={telegramIcon} alt='USP' /> :
          text?.label === "wechat" ?
            <img src={wechatIcon} alt='USP' /> :
            <img src={imIcon} alt='USP' />
        }
        {text?.value}</div>
    },
    // {
    //   title: "Phone Number",
    //   dataIndex: "Phone Number",
    //   width: 170,
    //   key: "Phone Number",
    //   hidden: !colvisAll["Phone Number"],
    //   sortDirections: ['ascend', 'descend', 'ascend'],
    //   // sorter: true,
    //   render: (text) => {
    //     return (<>
    //       {(text === "" || text === undefined || text === null) ? <><div className='text_dark'>-</div></> : <div className='text_dark'>{text}</div>}
    //     </>
    //     )
    //   }

    // },
    {
      title: "Country",
      dataIndex: "Country",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      width: 100,
      key: "Country",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisOnboarded["Country"],
      sorter: true,
      render: (text, record) => {
        return (
          <>{
            text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> :
              <Tooltip title={record.countryName}> <div><img src={text} alt={text} className="flag_icon" /></div></Tooltip>
          }
          </>
        )
      },
    },
    {
      title: 'AM',
      dataIndex: 'AM',
      key: "AM",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisOnboarded["AM"],
      // sorter: true,
      width: 300,
      render: (text, record) => {
        let selectedAMs = Array.isArray(text) ? text : []
        return (
          <div className={selectedAMs.length === 0 ? "checkbox_value_select_d2 multi_select_tag_d2 am_select_tag_new_design_empty" : "checkbox_value_select_d2 multi_select_tag_d2 am_select_tag_new_design"}>
            <Select
              value={selectedAMs}
              className={selectedAMs.length === 0 ? 'form_select tag_content--add' : "form_select tag_content--badge-grey"}
              dropdownStyle={{
                width: '22rem'
              }}
              mode='multiple'
              // maxTagCount='responsive'
              // placeholder='- Select -'
              placement="bottomLeft"
              popupClassName='diff_select_d2'
              showSearch={false}
              tagRender={(props) => {
                const { label } = props;

                return (
                  <>
                    {label}
                  </>
                );
              }}
              onChange={(selectedValues) => {
                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {
                  let token = Cookies.get("token_xapads_ssp");
                  let payload = { "am": selectedValues }
                  setLoading(true)
                  axios
                    .post(configData.SERVER_URL + `ops/add_acManager?_id=` + record._id, payload, {
                      headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                      },
                    })
                    .then((response) => {
                      setApicall(!apiCall)
                      notifysuccess(response.data.message);
                    })
                    .catch((error) => {
                      if (error?.response) {
                        if (error?.response?.data?.message?.length !== 0) {
                          notifyfailure(error.response.data.message)
                        }
                      }
                      else {
                        notifycatch()
                      }
                      setLoading(false)
                    });
                }
              }}
            >
              {accountManagerOptions.map(option => (
                <Select.Option key={option.value} value={option.value}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Checkbox
                      checked={selectedAMs.includes(option.value)}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {option.label}
                    </Checkbox>
                  </div>
                </Select.Option>
              ))}
            </Select>
          </div>
        )
      }

    },
    {
      title: "Seller Type",
      dataIndex: "Seller Type",
      width: 133,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "Seller Type",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisOnboarded["Seller Type"],
      sorter: true,
      render: (text) => {
        return (
          <>
            {text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> : <div className='tag_content--group'><div className='tag_content--grey'>{text}</div></div>}
          </>
        )
      }

    },
    {
      title: "GAM Integration",
      dataIndex: "GAM Integration",
      width: 130,
      key: "GAM Integration",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      hidden: !colvisOnboarded["GAM Integration"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      // sorter: true,
      render: (text) => <div className='text_dark'>{text}</div>,
    },
    // {
    //   title: "Media Kit",
    //   width: 80,
    //   key: "mediaKit",
    //   hidden: !colvisAll["Media Kit"],
    //   render: (_, record) => {
    //     return (
    //       record?.Onboarding === 2 && record["Media Kit"]?.length > 0 ?
    //         <button className='download_icon download_icon_d2'
    //           onClick={() => {
    //             fetchAndDownloadFiles(
    //               record["Media Kit"],
    //               // cell.row.original["title"],
    //               // cell.row.original["trackierCampaignId"]
    //             )

    //           }}
    //         ><img src={mediaKitIcon} alt='USP' /></button>
    //         : <><div className='text_dark'>-</div></>
    //     )
    //   }

    // },


    // {
    //   title: "Pixalate",
    //   onHeaderCell: () => ({
    //     className: 'diff_border_line_clr',
    //   }),
    //   hidden: !(
    //     colvisAll.impressions ||
    //     colvisAll.givtImpressions ||
    //     colvisAll.sivtImpressions ||
    //     colvisAll.givtSivtImp ||
    //     colvisAll.viewability ||
    //     colvisAll.discrep ||
    //     colvisAll.pix_updatedAt
    //   ),
    //   "children": [

    //     {
    //       title:

    //         <>

    //           <span >
    //             Gross Ad Count
    //             {columnPartialData ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeData})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //               :

    //               <Tooltip
    //                 title={`Complete Data (${columnTimeData})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>


    //         </>,
    //       dataIndex: "impressions",
    //       width: 170,
    //       key: "impressions",
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["impressions"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title:
    //         <>

    //           <span >
    //             GIVT Ad Count
    //             {columnPartialData ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeData})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>

    //               :
    //               <Tooltip
    //                 title={`Complete Data (${columnTimeData})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>


    //         </>,
    //       dataIndex: "givtImpressions",
    //       width: 170,
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       key: "givtImpressions",
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["givtImpressions"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)}  {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.givtImpsRate)}%)</span>}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title:
    //         <>

    //           <span >
    //             SIVT Ad Count
    //             {columnPartialData ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeData})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //               :
    //               <Tooltip
    //                 title={`Complete Data (${columnTimeData})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>


    //         </>,
    //       dataIndex: "sivtImpressions",
    //       width: 170,
    //       key: "sivtImpressions",
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["sivtImpressions"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)}   {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.sivtImpsRate)}%)</span>}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title: <>

    //         <span >
    //           IVT
    //           {columnPartialData ?
    //             <Tooltip
    //               title={`Partial Data (${columnTimeData})`}
    //             >
    //               <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //             </Tooltip>
    //             :
    //             <Tooltip
    //               title={`Complete Data (${columnTimeData})`}
    //             >
    //               <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //             </Tooltip>
    //           }
    //         </span>


    //       </>,
    //       dataIndex: "givtSivtImp",
    //       width: 160,
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       key: "givtSivtImp",
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["givtSivtImp"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)} {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.givtSivtRate)}%)</span>}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title:
    //         <>

    //           <span >
    //             Net Viewability
    //             {columnPartialData ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeData})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //               :
    //               <Tooltip
    //                 title={`Complete Data (${columnTimeData})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>



    //         </>,
    //       dataIndex: "viewability",
    //       width: 150,
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       key: "viewability",
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["viewability"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)} %
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title:
    //         <>

    //           <span >
    //             Discrepancies
    //             {columnPartialData ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeData})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>

    //               :
    //               <Tooltip
    //                 title={`Complete Data (${columnTimeData})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>

    //         </>,
    //       dataIndex: "discrep",
    //       width: 150,
    //       key: "discrep",
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["discrep"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 <span style={{ color: data.split(" ")[0] === "Low" ? "#0C875E" : data.split(" ")[0] === "High" ? "#FF0000" : "#EBB200" }}>{data.split(" ")[0]}</span> <span style={{ color: "#475467" }}>{data.split(" ")[1]}</span>
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title: "Updated At (UTC)",
    //       dataIndex: "pix_updatedAt",
    //       width: 150,
    //       key: "pix_updatedAt",
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["pix_updatedAt"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {data}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },

    //   ]
    // },

    // {
    //   title: "Human",
    //   onHeaderCell: () => ({
    //     className: 'diff_border_line_clr',
    //   }),
    //   hidden: !(
    //     colvisAll.hs_impressions ||
    //     colvisAll.hs_givtImpressions ||
    //     colvisAll.hs_sivtImpressions ||
    //     colvisAll.hs_ivtImpressions ||
    //     // colvisAll.viewability ||
    //     colvisAll.hs_discrep ||
    //     colvisAll.human_updatedAt
    //   ),
    //   "children": [

    //     {
    //       title:

    //         <>

    //           <span >
    //             Gross Ad Count
    //             {columnPartialDataHuman ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeDataHuman})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //               :

    //               <Tooltip
    //                 title={`Complete Data (${columnTimeDataHuman})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>


    //         </>,
    //       dataIndex: "hs_impressions",
    //       width: 170,
    //       key: "hs_impressions",
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["hs_impressions"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title:
    //         <>

    //           <span >
    //             GIVT Ad Count
    //             {columnPartialDataHuman ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeDataHuman})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>

    //               :
    //               <Tooltip
    //                 title={`Complete Data (${columnTimeDataHuman})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>


    //         </>,
    //       dataIndex: "hs_givtImpressions",
    //       width: 170,
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       key: "hs_givtImpressions",
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["hs_givtImpressions"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)}  {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.hs_givtRate)}%)</span>}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title:
    //         <>

    //           <span >
    //             SIVT Ad Count
    //             {columnPartialDataHuman ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeDataHuman})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //               :
    //               <Tooltip
    //                 title={`Complete Data (${columnTimeDataHuman})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>


    //         </>,
    //       dataIndex: "hs_sivtImpressions",
    //       width: 170,
    //       key: "hs_sivtImpressions",
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["hs_sivtImpressions"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)}   {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.hs_sivtRate)}%)</span>}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title: <>

    //         <span >
    //           IVT
    //           {columnPartialDataHuman ?
    //             <Tooltip
    //               title={`Partial Data (${columnTimeDataHuman})`}
    //             >
    //               <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //             </Tooltip>
    //             :
    //             <Tooltip
    //               title={`Complete Data (${columnTimeDataHuman})`}
    //             >
    //               <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //             </Tooltip>
    //           }
    //         </span>


    //       </>,
    //       dataIndex: "hs_ivtImpressions",
    //       width: 160,
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       key: "hs_ivtImpressions",
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["hs_ivtImpressions"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)} {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.hs_ivtRate)}%)</span>}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     // {
    //     //     title:
    //     //         <>

    //     //             <span >
    //     //                 Net Viewability
    //     //                 {columnPartialData ?
    //     //                     <Tooltip
    //     //                         title={`Partial Data (${columnTimeData})`}
    //     //                     >
    //     //                         <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //     //                     </Tooltip>
    //     //                     :
    //     //                     <Tooltip
    //     //                         title={`Complete Data (${columnTimeData})`}
    //     //                     >
    //     //                         <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //     //                     </Tooltip>
    //     //                 }
    //     //             </span>



    //     //         </>,
    //     //     dataIndex: "viewability",
    //     //     width: 150,
    //     //     onHeaderCell: () => ({
    //     //         className: 'border_right_0',
    //     //     }),
    //     //     key: "viewability",
    //     //     sortDirections: ['ascend', 'descend', 'ascend'],
    //     //     sorter: true,
    //     //     hidden: !colvisAll["viewability"],
    //     //     render: (data, record) => {
    //     //         return (
    //     //             <>
    //     //                 {(data === "" || data === undefined || data === null) ?
    //     //                     <>
    //     //                         <div className='text_dark'>-</div>
    //     //                     </>
    //     //                     :
    //     //                     <>
    //     //                         {addCommasToNumber(data)} %
    //     //                     </>
    //     //                 }
    //     //             </>
    //     //         )
    //     //     },
    //     // },
    //     {
    //       title:
    //         <>

    //           <span >
    //             Discrepancies
    //             {columnPartialDataHuman ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeDataHuman})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>

    //               :
    //               <Tooltip
    //                 title={`Complete Data (${columnTimeDataHuman})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>

    //         </>,
    //       dataIndex: "hs_discrep",
    //       width: 150,
    //       key: "hs_discrep",
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["hs_discrep"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 <span style={{ color: data.split(" ")[0] === "Low" ? "#0C875E" : data.split(" ")[0] === "High" ? "#FF0000" : "#EBB200" }}>{data.split(" ")[0]}</span> <span style={{ color: "#475467" }}>{data.split(" ")[1]}</span>
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title: "Updated At (UTC)",
    //       dataIndex: "human_updatedAt",
    //       width: 150,
    //       key: "human_updatedAt",
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["human_updatedAt"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {data}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },

    //   ]
    // }
    {
      title: "Check In",
      key: "checkIn",
      // fixed: 'right',
      width: 80,
      render: (_, record) => (
        <div className='download_icon download_icon_d2'
          onClick={() => {
            setIsCheckinUserVisible(true)
            setCheckinUser(record)
          }
          }

        >
          <Tooltip title="Check In">
            <img src={CheckInIcon} className='img-fluid cursor_pointer' />
          </Tooltip>
        </div >
      ),
    },

  ];

  const columnsRejected = [
    {
      title: "Action",
      key: "action",
      // render: (data) => <div className='badge_content--approved'>{data}</div>,
      fixed: 'left',
      width: 30,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),

      render: (_, record) => <div className='btn_group' style={{
        width: '2.6rem'
      }}>
        <Tooltip title="Approve">
          <button className='btn_outline_success btn --diff_clr_of_approved_box' style={{ width: '2.8rem' }}
            disabled={!record.onboard_filled} onClick={() => { statusChange("approved", record._id, record.approvedOnce) }}
          >
            <img src={checkIcon} alt='USP' />
            {/* Approve */}
          </button>
        </Tooltip>
      </div>,


    },
    {
      title: "Name",
      dataIndex: "Name",
      key: "Name",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      fixed: 'left',
      width: 300,
      render: (data, record) => <div className='anchor_text_link_d2'
        onClick={() => {
          setPageView("view");
          setPublisherViewId(record._id)
          setPublisherViewName(record.Name)
          setAccountStatus(record.Status)
        }}

      >{data}</div>,
      // width: 220,
    },
    {
      title: "Organization Name",
      dataIndex: "Organization Name",
      width: 300,
      key: "Organization Name",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (data) => <div className='text_dark'>{data}</div>,
    },
    {
      title: "Email",
      dataIndex: "Email",
      key: "Email",
      // width: 200,
      sorter: true,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      hidden: !colvisRejected["Email"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      // sortOrder: sort.name === 'Email' ? sort.type : null,
      render: (data) => <Tooltip title={data}><div className='text_dark'>{data}</div></Tooltip>,
    },
    {
      title: "Website",
      dataIndex: "Website",
      // width: 200,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "Website",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisRejected["Website"],
      sorter: true,
      render: (data) => <a href={data.includes("https://") ? data : "https://" + data} target="_blank" className='text_primary' >{data}</a>,
    },
    {
      title: "IM",
      dataIndex: "IM",
      // width: 200,
      key: "IM.value",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisRejected["IM"],
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      // sorter: true,
      render: (text) => <div className='im_type text_dark'>
        {text?.label === "telegram" ?
          <img src={telegramIcon} alt='USP' /> :
          text?.label === "wechat" ?
            <img src={wechatIcon} alt='USP' /> :
            <img src={imIcon} alt='USP' />
        }
        {text?.value}</div>
    },
    // {
    //   title: "Phone Number",
    //   dataIndex: "Phone Number",
    //   width: 170,
    //   key: "Phone Number",
    //   hidden: !colvisAll["Phone Number"],
    //   sortDirections: ['ascend', 'descend', 'ascend'],
    //   // sorter: true,
    //   render: (text) => {
    //     return (<>
    //       {(text === "" || text === undefined || text === null) ? <><div className='text_dark'>-</div></> : <div className='text_dark'>{text}</div>}
    //     </>
    //     )
    //   }

    // },
    {
      title: "Country",
      dataIndex: "Country",
      width: 100,
      key: "Country",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisRejected["Country"],
      sorter: true,
      render: (text, record) => {
        return (
          <>{
            text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> :
              <Tooltip title={record.countryName}> <div><img src={text} alt={text} className="flag_icon" /></div></Tooltip>
          }
          </>
        )
      },
    },
    {
      title: 'AM',
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      dataIndex: 'AM',
      key: "AM",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisRejected["AM"],
      // sorter: true,
      width: 300,
      render: (text, record) => {
        let selectedAMs = Array.isArray(text) ? text : []
        return (
          <div className={selectedAMs.length === 0 ? "checkbox_value_select_d2 multi_select_tag_d2 am_select_tag_new_design_empty" : "checkbox_value_select_d2 multi_select_tag_d2 am_select_tag_new_design"}>
            <Select
              value={selectedAMs}
              className={selectedAMs.length === 0 ? 'form_select tag_content--add' : "form_select tag_content--badge-grey"}
              dropdownStyle={{
                width: '22rem'
              }}
              mode='multiple'
              // maxTagCount='responsive'
              // placeholder='- Select -'
              placement="bottomLeft"
              popupClassName='diff_select_d2'
              showSearch={false}
              tagRender={(props) => {
                const { label } = props;

                return (
                  <>
                    {label}
                  </>
                );
              }}
              onChange={(selectedValues) => {
                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {
                  let token = Cookies.get("token_xapads_ssp");
                  let payload = { "am": selectedValues }
                  setLoading(true)
                  axios
                    .post(configData.SERVER_URL + `ops/add_acManager?_id=` + record._id, payload, {
                      headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                      },
                    })
                    .then((response) => {
                      setApicall(!apiCall)
                      notifysuccess(response.data.message);
                    })
                    .catch((error) => {
                      if (error?.response) {
                        if (error?.response?.data?.message?.length !== 0) {
                          notifyfailure(error.response.data.message)
                        }
                      }
                      else {
                        notifycatch()
                      }
                      setLoading(false)
                    });
                }
              }}
            >
              {accountManagerOptions.map(option => (
                <Select.Option key={option.value} value={option.value}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Checkbox
                      checked={selectedAMs.includes(option.value)}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {option.label}
                    </Checkbox>
                  </div>
                </Select.Option>
              ))}
            </Select>
          </div>
        )
      }

    },
    {
      title: "Seller Type",
      dataIndex: "Seller Type",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      width: 133,
      key: "Seller Type",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisRejected["Seller Type"],
      sorter: true,
      render: (text) => {
        return (
          <>
            {text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> : <div className='tag_content--group'><div className='tag_content--grey'>{text}</div></div>}
          </>
        )
      }

    },
    {
      title: "GAM Integration",
      dataIndex: "GAM Integration",
      width: 130,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "GAM Integration",
      hidden: !colvisRejected["GAM Integration"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      // sorter: true,
      render: (text) => <div className='text_dark'>{text}</div>,
    },
    // {
    //   title: "Media Kit",
    //   width: 80,
    //   key: "mediaKit",
    //   hidden: !colvisAll["Media Kit"],
    //   render: (_, record) => {
    //     return (
    //       record?.Onboarding === 2 && record["Media Kit"]?.length > 0 ?
    //         <button className='download_icon download_icon_d2'
    //           onClick={() => {
    //             fetchAndDownloadFiles(
    //               record["Media Kit"],
    //               // cell.row.original["title"],
    //               // cell.row.original["trackierCampaignId"]
    //             )

    //           }}
    //         ><img src={mediaKitIcon} alt='USP' /></button>
    //         : <><div className='text_dark'>-</div></>
    //     )
    //   }

    // },


    // {
    //   title: "Pixalate",
    //   onHeaderCell: () => ({
    //     className: 'diff_border_line_clr',
    //   }),
    //   hidden: !(
    //     colvisAll.impressions ||
    //     colvisAll.givtImpressions ||
    //     colvisAll.sivtImpressions ||
    //     colvisAll.givtSivtImp ||
    //     colvisAll.viewability ||
    //     colvisAll.discrep ||
    //     colvisAll.pix_updatedAt
    //   ),
    //   "children": [

    //     {
    //       title:

    //         <>

    //           <span >
    //             Gross Ad Count
    //             {columnPartialData ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeData})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //               :

    //               <Tooltip
    //                 title={`Complete Data (${columnTimeData})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>


    //         </>,
    //       dataIndex: "impressions",
    //       width: 170,
    //       key: "impressions",
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["impressions"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title:
    //         <>

    //           <span >
    //             GIVT Ad Count
    //             {columnPartialData ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeData})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>

    //               :
    //               <Tooltip
    //                 title={`Complete Data (${columnTimeData})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>


    //         </>,
    //       dataIndex: "givtImpressions",
    //       width: 170,
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       key: "givtImpressions",
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["givtImpressions"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)}  {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.givtImpsRate)}%)</span>}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title:
    //         <>

    //           <span >
    //             SIVT Ad Count
    //             {columnPartialData ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeData})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //               :
    //               <Tooltip
    //                 title={`Complete Data (${columnTimeData})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>


    //         </>,
    //       dataIndex: "sivtImpressions",
    //       width: 170,
    //       key: "sivtImpressions",
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["sivtImpressions"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)}   {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.sivtImpsRate)}%)</span>}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title: <>

    //         <span >
    //           IVT
    //           {columnPartialData ?
    //             <Tooltip
    //               title={`Partial Data (${columnTimeData})`}
    //             >
    //               <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //             </Tooltip>
    //             :
    //             <Tooltip
    //               title={`Complete Data (${columnTimeData})`}
    //             >
    //               <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //             </Tooltip>
    //           }
    //         </span>


    //       </>,
    //       dataIndex: "givtSivtImp",
    //       width: 160,
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       key: "givtSivtImp",
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["givtSivtImp"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)} {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.givtSivtRate)}%)</span>}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title:
    //         <>

    //           <span >
    //             Net Viewability
    //             {columnPartialData ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeData})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //               :
    //               <Tooltip
    //                 title={`Complete Data (${columnTimeData})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>



    //         </>,
    //       dataIndex: "viewability",
    //       width: 150,
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       key: "viewability",
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["viewability"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)} %
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title:
    //         <>

    //           <span >
    //             Discrepancies
    //             {columnPartialData ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeData})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>

    //               :
    //               <Tooltip
    //                 title={`Complete Data (${columnTimeData})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>

    //         </>,
    //       dataIndex: "discrep",
    //       width: 150,
    //       key: "discrep",
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["discrep"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 <span style={{ color: data.split(" ")[0] === "Low" ? "#0C875E" : data.split(" ")[0] === "High" ? "#FF0000" : "#EBB200" }}>{data.split(" ")[0]}</span> <span style={{ color: "#475467" }}>{data.split(" ")[1]}</span>
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title: "Updated At (UTC)",
    //       dataIndex: "pix_updatedAt",
    //       width: 150,
    //       key: "pix_updatedAt",
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["pix_updatedAt"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {data}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },

    //   ]
    // },

    // {
    //   title: "Human",
    //   onHeaderCell: () => ({
    //     className: 'diff_border_line_clr',
    //   }),
    //   hidden: !(
    //     colvisAll.hs_impressions ||
    //     colvisAll.hs_givtImpressions ||
    //     colvisAll.hs_sivtImpressions ||
    //     colvisAll.hs_ivtImpressions ||
    //     // colvisAll.viewability ||
    //     colvisAll.hs_discrep ||
    //     colvisAll.human_updatedAt
    //   ),
    //   "children": [

    //     {
    //       title:

    //         <>

    //           <span >
    //             Gross Ad Count
    //             {columnPartialDataHuman ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeDataHuman})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //               :

    //               <Tooltip
    //                 title={`Complete Data (${columnTimeDataHuman})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>


    //         </>,
    //       dataIndex: "hs_impressions",
    //       width: 170,
    //       key: "hs_impressions",
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["hs_impressions"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title:
    //         <>

    //           <span >
    //             GIVT Ad Count
    //             {columnPartialDataHuman ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeDataHuman})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>

    //               :
    //               <Tooltip
    //                 title={`Complete Data (${columnTimeDataHuman})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>


    //         </>,
    //       dataIndex: "hs_givtImpressions",
    //       width: 170,
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       key: "hs_givtImpressions",
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["hs_givtImpressions"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)}  {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.hs_givtRate)}%)</span>}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title:
    //         <>

    //           <span >
    //             SIVT Ad Count
    //             {columnPartialDataHuman ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeDataHuman})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //               :
    //               <Tooltip
    //                 title={`Complete Data (${columnTimeDataHuman})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>


    //         </>,
    //       dataIndex: "hs_sivtImpressions",
    //       width: 170,
    //       key: "hs_sivtImpressions",
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["hs_sivtImpressions"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)}   {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.hs_sivtRate)}%)</span>}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title: <>

    //         <span >
    //           IVT
    //           {columnPartialDataHuman ?
    //             <Tooltip
    //               title={`Partial Data (${columnTimeDataHuman})`}
    //             >
    //               <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //             </Tooltip>
    //             :
    //             <Tooltip
    //               title={`Complete Data (${columnTimeDataHuman})`}
    //             >
    //               <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //             </Tooltip>
    //           }
    //         </span>


    //       </>,
    //       dataIndex: "hs_ivtImpressions",
    //       width: 160,
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       key: "hs_ivtImpressions",
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["hs_ivtImpressions"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {addCommasToNumber(data)} {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.hs_ivtRate)}%)</span>}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     // {
    //     //     title:
    //     //         <>

    //     //             <span >
    //     //                 Net Viewability
    //     //                 {columnPartialData ?
    //     //                     <Tooltip
    //     //                         title={`Partial Data (${columnTimeData})`}
    //     //                     >
    //     //                         <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //     //                     </Tooltip>
    //     //                     :
    //     //                     <Tooltip
    //     //                         title={`Complete Data (${columnTimeData})`}
    //     //                     >
    //     //                         <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //     //                     </Tooltip>
    //     //                 }
    //     //             </span>



    //     //         </>,
    //     //     dataIndex: "viewability",
    //     //     width: 150,
    //     //     onHeaderCell: () => ({
    //     //         className: 'border_right_0',
    //     //     }),
    //     //     key: "viewability",
    //     //     sortDirections: ['ascend', 'descend', 'ascend'],
    //     //     sorter: true,
    //     //     hidden: !colvisAll["viewability"],
    //     //     render: (data, record) => {
    //     //         return (
    //     //             <>
    //     //                 {(data === "" || data === undefined || data === null) ?
    //     //                     <>
    //     //                         <div className='text_dark'>-</div>
    //     //                     </>
    //     //                     :
    //     //                     <>
    //     //                         {addCommasToNumber(data)} %
    //     //                     </>
    //     //                 }
    //     //             </>
    //     //         )
    //     //     },
    //     // },
    //     {
    //       title:
    //         <>

    //           <span >
    //             Discrepancies
    //             {columnPartialDataHuman ?
    //               <Tooltip
    //                 title={`Partial Data (${columnTimeDataHuman})`}
    //               >
    //                 <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>

    //               :
    //               <Tooltip
    //                 title={`Complete Data (${columnTimeDataHuman})`}
    //               >
    //                 <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
    //               </Tooltip>
    //             }
    //           </span>

    //         </>,
    //       dataIndex: "hs_discrep",
    //       width: 150,
    //       key: "hs_discrep",
    //       onHeaderCell: () => ({
    //         className: 'border_right_0',
    //       }),
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["hs_discrep"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 <span style={{ color: data.split(" ")[0] === "Low" ? "#0C875E" : data.split(" ")[0] === "High" ? "#FF0000" : "#EBB200" }}>{data.split(" ")[0]}</span> <span style={{ color: "#475467" }}>{data.split(" ")[1]}</span>
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },
    //     {
    //       title: "Updated At (UTC)",
    //       dataIndex: "human_updatedAt",
    //       width: 150,
    //       key: "human_updatedAt",
    //       sortDirections: ['ascend', 'descend', 'ascend'],
    //       sorter: true,
    //       hidden: !colvisAll["human_updatedAt"],
    //       render: (data, record) => {
    //         return (
    //           <>
    //             {(data === "" || data === undefined || data === null) ?
    //               <>
    //                 <div className='text_dark'>-</div>
    //               </>
    //               :
    //               <>
    //                 {data}
    //               </>
    //             }
    //           </>
    //         )
    //       },
    //     },

    //   ]
    // }
    {
      title: "Check In",
      key: "checkIn",
      // fixed: 'right',
      width: 80,
      render: (_, record) => (
        <div className='download_icon download_icon_d2'
          onClick={() => {
            setIsCheckinUserVisible(true)
            setCheckinUser(record)
          }
          }

        >
          <Tooltip title="Check In">
            <img src={CheckInIcon} className='img-fluid cursor_pointer' />
          </Tooltip>
        </div >
      ),
    },

  ];

  const [checkRole, setCheckRole] = useState("sa");

  const columnsApproved = [
    {
      title: "Action",
      dataIndex: "Status",
      key: "Status",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      // render: (data) => <div className='badge_content--approved'>{data}</div>,
      fixed: 'left',
      width: 120,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      render: (text, record) => {
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
          let userRole = jwtDecode(Cookies.get("token_xapads_ssp"))?.role


          return (

            <div className='w_100 position-relative'>
              <Select
                className={`form_select badge_content--${text?.toLowerCase()}`}
                dropdownStyle={{
                  width: '12rem'
                }}
                style={{ pointerEvents: userRole === "am" ? "none" : "default" }}
                value={text?.toLowerCase()}

                options={userRole === "am" ?
                  [{ label: "Approved", value: "approved" },
                  { label: "Archived", value: "archived" },
                  { label: "Declined", value: "declined" },
                  { label: "New", value: "new" },
                  { label: "Onboarded", value: "onboard" },
                  { label: "Rejected", value: "rejected" }]
                  :
                  [{ label: "Approved", value: "approved" },
                  { label: "Archived", value: "archived" },
                  { label: "Declined", value: "declined" }
                  ]
                }
                onChange={(event) => {
                  // if (event.toLowerCase() !== text.toLowerCase()) {

                  if (event === "archived") {
                    setArchivePendingRecord({ event, record });
                    setArchiveModalOpen(true);
                    return;
                  }

                  let status = Cookies.get("token_xapads_ssp") ? true : false;
                  if (status) {
                    let token = Cookies.get("token_xapads_ssp");

                    let payload = {
                      "status": event,
                      "_id": record?._id,
                      "approvedOnce": record?.approvedOnce
                    }

                    setLoading(true)
                    axios
                      .post(configData.SERVER_URL + `ops/statusUpdate`, payload, {
                        headers: {
                          "Content-Type": "application/json",
                          "x-access-token": token,
                        },
                      })
                      .then((response) => {
                        setApicall(!apiCall)
                        notifysuccess(response.data.message);

                      })
                      .catch((error) => {
                        if (error.response.data.message?.length !== 0) {
                          notifyfailure(error.response.data.message)
                        }
                        else {
                          notifycatch()
                        }
                        setLoading(false)

                      });

                  }
                  // }
                }
                }
              />
            </div>
          )
        }
      }


    },

    {
      title: "Name",
      dataIndex: "Name",
      key: "Name",
      sorter: true,
      sortDirections: ['ascend', 'descend', 'ascend'],
      fixed: 'left',
      width: 160,
      render: (data, record) => <div className='anchor_text_link_d2'
        onClick={() => {
          setPageView("view");
          setPublisherViewId(record._id)
          setPublisherViewName(record.Name)
          setAccountStatus(record.Status)
        }}

      >{data}</div>,
      // width: 220,
    },

    {
      title: "Organization Name",
      dataIndex: "Organization Name",
      width: 200,
      key: "Organization Name",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (data) => <div className='text_dark'>{data}</div>,
    },
    {
      title: "Email",
      dataIndex: "Email",
      key: "Email",
      // width: 200,
      sorter: true,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      hidden: !colvisApproved["Email"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      // sortOrder: sort.name === 'Email' ? sort.type : null,
      render: (data) => <Tooltip title={data}><div className='text_dark'>{data}</div></Tooltip>,
    },
    {
      title: "Website",
      dataIndex: "Website",
      width: 200,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "Website",
      hidden: !colvisApproved["Website"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (data) => <a href={data.includes("https://") ? data : "https://" + data} target="_blank" className='text_primary' >{data}</a>,
    },
    {
      title: "IM",
      dataIndex: "IM",
      // width: 200,
      key: "IM.value",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      hidden: !colvisApproved["IM"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      // sorter: true,
      render: (text) => <div className='im_type text_dark'>
        {text?.label === "telegram" ?
          <img src={telegramIcon} alt='USP' /> :
          text?.label === "wechat" ?
            <img src={wechatIcon} alt='USP' /> :
            <img src={imIcon} alt='USP' />
        }
        {text?.value}</div>
    },

    {
      title: "Country",
      dataIndex: "Country",
      hidden: !colvisApproved["Country"],
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      width: 100,
      key: "Country",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (text, record) => {
        return (
          <>{
            text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> :
              <Tooltip title={record.countryName}> <div><img src={text} alt={text} className="flag_icon" /></div></Tooltip>
          }
          </>
        )
      },
    },
    {
      title: "Zones",
      dataIndex: "zone",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      width: 80,
      key: "zone",
      sortDirections: ['ascend', 'descend', 'ascend'],
      hidden: !colvisApproved["zone"],
      // sorter: true,
      render: (data, record) => <div className='text_dark'>
        {record.Status === "Approved" && data === 0 ?

          <Link className="zero_value_design2" style={{ textDecoration: "none", cursor: "default" }} >{data}</Link> :
          record.Status === "Approved" && data !== 0 ?
            <Link to={`/zoneList?publisher=${record["ADK ID"]}-${record["Name"]}`} target="_blank" className='text_primary back_area_increase_d2'>{data}</Link>
            : <div className='text_dark back_area_increase_d2'>-</div>}
      </div>,
    },
    {
      title: 'AM',
      dataIndex: 'AM',
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "AM",
      hidden: !colvisApproved["AM"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      // sorter: true,
      // width: 150,
      render: (text, record) => {
        let selectedAMs = Array.isArray(text) ? text : []

        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
          let userRole = jwtDecode(Cookies.get("token_xapads_ssp"))?.role


          return (

            <div className={selectedAMs.length === 0 ? "checkbox_value_select_d2 multi_select_tag_d2 am_select_tag_new_design_empty" : "checkbox_value_select_d2 multi_select_tag_d2 am_select_tag_new_design"}
              style={{ pointerEvents: userRole === "am" ? "none" : "default" }}
            >
              <Select
                value={selectedAMs}
                className={selectedAMs.length === 0 ? 'form_select tag_content--add' : "form_select tag_content--badge-grey"}
                dropdownStyle={{
                  width: '22rem'
                }}
                mode='multiple'
                // maxTagCount='responsive'
                placement="bottomLeft"
                // placeholder='- Select -'
                popupClassName='diff_select_d2'
                showSearch={false}
                tagRender={(props) => {
                  const { label } = props;

                  return (
                    <>
                      {label}
                    </>
                  );
                }}
                onChange={(selectedValues) => {
                  let status = Cookies.get("token_xapads_ssp") ? true : false;
                  if (status) {
                    let token = Cookies.get("token_xapads_ssp");
                    let payload = { "am": selectedValues }
                    setLoading(true)
                    axios
                      .post(configData.SERVER_URL + `ops/add_acManager?_id=` + record._id, payload, {
                        headers: {
                          "Content-Type": "application/json",
                          "x-access-token": token,
                        },
                      })
                      .then((response) => {
                        setApicall(!apiCall)
                        notifysuccess(response.data.message);
                      })
                      .catch((error) => {
                        if (error?.response) {
                          if (error?.response?.data?.message?.length !== 0) {
                            notifyfailure(error.response.data.message)
                          }
                        }
                        else {
                          notifycatch()
                        }
                        setLoading(false)
                      });
                  }
                }}
              >
                {accountManagerOptions.map(option => (
                  <Select.Option key={option.value} value={option.value}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Checkbox
                        checked={selectedAMs.includes(option.value)}
                        onClick={(e) => e.stopPropagation()}
                      >
                        {option.label}
                      </Checkbox>
                    </div>
                  </Select.Option>
                ))}
              </Select>
            </div>
          )
        }
      }

    },
    {
      title: "Seller Type",
      dataIndex: "Seller Type",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      hidden: !colvisApproved["Seller Type"],
      width: 133,
      key: "Seller Type",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,

      render: (text) => {
        return (
          <>
            {text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> : <div className='tag_content--group'><div className='tag_content--grey'>{text}</div></div>}
          </>
        )
      }

    },
    {
      title: "GAM Integration",
      dataIndex: "GAM Integration",
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      hidden: !colvisApproved["GAM Integration"],
      width: 120,
      key: "GAM Integration",
      sortDirections: ['ascend', 'descend', 'ascend'],
      // sorter: true,
      render: (text) => <div className='text_dark'>{text}</div>,
    },

    {
      title: "ADK ID",
      dataIndex: "ADK ID",
      hidden: !colvisApproved["ADK ID"],
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      width: 90,
      key: "ADK ID",
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (text) => {
        return (
          <>
            {text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> : <>{text}</>}
          </>
        )
      }
    },
    {
      title: "Aniview ID",
      dataIndex: "Aniview ID",
      width: 230,
      onHeaderCell: () => ({
        className: 'border_right_0',
      }),
      key: "Aniview ID",
      hidden: !colvisApproved["Aniview ID"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (text, record) => {
        return (
          <>
            {(text === "" || text === null || text === undefined) && record.Status === "Approved" ?
              <>
                <div className='text_dark'>
                  {record?.aniviewLoading ?

                    <button className="new_integrate_btn_d2 btn btn_primary loader loader_btn_with_icon">
                      <span> Integrate</span>
                      <img src={FullLoader} alt="USP" className="" />
                    </button>
                    :
                    <button className="new_integrate_btn_d2" onClick={() => { handleAniviewIdCreate(record) }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M7.5 5L10 7.5L7.5 10" stroke="#8952E0" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M2 2V5.5C2 6.03043 2.21071 6.53914 2.58579 6.91421C2.96086 7.28929 3.46957 7.5 4 7.5H10" stroke="#8952E0" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      Integrate
                    </button>
                  }
                </div>
              </>
              :
              (text === "" || text === null || text === undefined) && record.Status !== "Approved" ?
                <><div className='text_dark'>-</div></>
                :
                <>
                  {text}
                </>}
          </>
        )
      }
    },
    {
      title: "GAM ID",
      dataIndex: "GAM ID",
      width: 120,
      key: "GAM ID",
      hidden: !colvisApproved["GAM ID"],
      sortDirections: ['ascend', 'descend', 'ascend'],
      sorter: true,
      render: (text) => {
        return (
          <>
            {text === "" || text === null || text === undefined ? <><div className='text_dark'>-</div></> : <>{text}</>}
          </>
        )
      }
    },

    // ===== PIXALATE SUNSET: Pixalate column group disabled (data no longer returned by API). Restore by changing false -> true. =====
    ...(false ? [{
      title: <span >
        Pixalate
        {columnPartialData ?
          <Tooltip
            title={`Partial Data (${columnTimeData})`}
          >
            <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
          </Tooltip>
          :
          <Tooltip
            title={`Complete Data (${columnTimeData})`}
          >
            <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
          </Tooltip>
        }
      </span>,


      onHeaderCell: () => ({
        className: 'diff_border_line_clr table_diff_colors',
      }),
      onCell: () => ({
        className: "table_diff_colors_td"
      }),
      hidden: !(
        // colvisAll.impressions ||
        // colvisAll.givtImpressions ||
        // colvisAll.sivtImpressions ||
        colvisApproved.givtSivtImp ||
        colvisApproved.viewability ||
        colvisApproved.discrep ||
        colvisApproved.pix_updatedAt
      ),
      "children": [

        // {
        //   title:

        //     <>

        //       <span >
        //         Gross Ad Count
        //         {columnPartialData ?
        //           <Tooltip
        //             title={`Partial Data (${columnTimeData})`}
        //           >
        //             <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
        //           </Tooltip>
        //           :

        //           <Tooltip
        //             title={`Complete Data (${columnTimeData})`}
        //           >
        //             <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
        //           </Tooltip>
        //         }
        //       </span>


        //     </>,
        //   dataIndex: "impressions",
        //   width: 170,
        //   key: "impressions",
        //   onHeaderCell: () => ({
        //     className: 'border_right_0',
        //   }),
        //   sortDirections: ['ascend', 'descend', 'ascend'],
        //   sorter: true,
        //   hidden: !colvisAll["impressions"],
        //   render: (data, record) => {
        //     return (
        //       <>
        //         {(data === "" || data === undefined || data === null) ?
        //           <>
        //             <div className='text_dark'>-</div>
        //           </>
        //           :
        //           <>
        //             {addCommasToNumber(data)}
        //           </>
        //         }
        //       </>
        //     )
        //   },
        // },
        // {
        //   title:
        //     <>

        //       <span >
        //         GIVT Ad Count
        //         {columnPartialData ?
        //           <Tooltip
        //             title={`Partial Data (${columnTimeData})`}
        //           >
        //             <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
        //           </Tooltip>

        //           :
        //           <Tooltip
        //             title={`Complete Data (${columnTimeData})`}
        //           >
        //             <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
        //           </Tooltip>
        //         }
        //       </span>


        //     </>,
        //   dataIndex: "givtImpressions",
        //   width: 170,
        //   onHeaderCell: () => ({
        //     className: 'border_right_0',
        //   }),
        //   key: "givtImpressions",
        //   sortDirections: ['ascend', 'descend', 'ascend'],
        //   sorter: true,
        //   hidden: !colvisAll["givtImpressions"],
        //   render: (data, record) => {
        //     return (
        //       <>
        //         {(data === "" || data === undefined || data === null) ?
        //           <>
        //             <div className='text_dark'>-</div>
        //           </>
        //           :
        //           <>
        //             {addCommasToNumber(data)}  {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.givtImpsRate)}%)</span>}
        //           </>
        //         }
        //       </>
        //     )
        //   },
        // },
        // {
        //   title:
        //     <>

        //       <span >
        //         SIVT Ad Count
        //         {columnPartialData ?
        //           <Tooltip
        //             title={`Partial Data (${columnTimeData})`}
        //           >
        //             <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
        //           </Tooltip>
        //           :
        //           <Tooltip
        //             title={`Complete Data (${columnTimeData})`}
        //           >
        //             <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
        //           </Tooltip>
        //         }
        //       </span>


        //     </>,
        //   dataIndex: "sivtImpressions",
        //   width: 170,
        //   key: "sivtImpressions",
        //   onHeaderCell: () => ({
        //     className: 'border_right_0',
        //   }),
        //   sortDirections: ['ascend', 'descend', 'ascend'],
        //   sorter: true,
        //   hidden: !colvisAll["sivtImpressions"],
        //   render: (data, record) => {
        //     return (
        //       <>
        //         {(data === "" || data === undefined || data === null) ?
        //           <>
        //             <div className='text_dark'>-</div>
        //           </>
        //           :
        //           <>
        //             {addCommasToNumber(data)}   {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.sivtImpsRate)}%)</span>}
        //           </>
        //         }
        //       </>
        //     )
        //   },
        // },
        {
          title: <>

            <span >
              IVT
              {/* {columnPartialData ?
                <Tooltip
                  title={`Partial Data (${columnTimeData})`}
                >
                  <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                </Tooltip>
                :
                <Tooltip
                  title={`Complete Data (${columnTimeData})`}
                >
                  <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                </Tooltip>
              } */}
            </span>


          </>,
          dataIndex: "givtSivtImp",
          width: 160,
          onHeaderCell: () => ({
            className: 'border_right_0 table_diff_colors',
          }),
          onCell: () => ({
            className: "table_diff_colors_td"
          }),
          key: "givtSivtImp",
          sortDirections: ['ascend', 'descend', 'ascend'],
          sorter: true,
          hidden: !colvisApproved["givtSivtImp"],
          render: (data, record) => {
            return (
              <>
                {(data === "" || data === undefined || data === null) ?
                  <>
                    <div className='text_dark'>-</div>
                  </>
                  :
                  <>
                    {addCommasToNumber(data)} {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.givtSivtRate)}%)</span>}
                  </>
                }
              </>
            )
          },
        },
        {
          title:
            <>

              <span >
                Net Viewability
                {/* {columnPartialData ?
                  <Tooltip
                    title={`Partial Data (${columnTimeData})`}
                  >
                    <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                  </Tooltip>
                  :
                  <Tooltip
                    title={`Complete Data (${columnTimeData})`}
                  >
                    <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                  </Tooltip>
                } */}
              </span>



            </>,
          dataIndex: "viewability",
          width: 150,
          onHeaderCell: () => ({
            className: 'border_right_0 table_diff_colors',
          }),
          onCell: () => ({
            className: "table_diff_colors_td"
          }),
          key: "viewability",
          sortDirections: ['ascend', 'descend', 'ascend'],
          sorter: true,
          hidden: !colvisApproved["viewability"],
          render: (data, record) => {
            return (
              <>
                {(data === "" || data === undefined || data === null) ?
                  <>
                    <div className='text_dark'>-</div>
                  </>
                  :
                  <>
                    {addCommasToNumber(data)} %
                  </>
                }
              </>
            )
          },
        },
        {
          title:
            <>

              <span >
                Discrepancies
                {/* {columnPartialData ?
                  <Tooltip
                    title={`Partial Data (${columnTimeData})`}
                  >
                    <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                  </Tooltip>

                  :
                  <Tooltip
                    title={`Complete Data (${columnTimeData})`}
                  >
                    <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                  </Tooltip>
                } */}
              </span>

            </>,
          dataIndex: "discrep",
          width: 150,
          key: "discrep",
          onHeaderCell: () => ({
            className: 'border_right_0 table_diff_colors',
          }),
          onCell: () => ({
            className: "table_diff_colors_td"
          }),
          sortDirections: ['ascend', 'descend', 'ascend'],
          sorter: true,
          hidden: !colvisApproved["discrep"],
          render: (data, record) => {
            return (
              <>
                {(data === "" || data === undefined || data === null) ?
                  <>
                    <div className='text_dark'>-</div>
                  </>
                  :
                  <>
                    <span style={{ color: data.split(" ")[0] === "Low" ? "#0C875E" : data.split(" ")[0] === "High" ? "#FF0000" : "#EBB200" }}>{data.split(" ")[0]}</span> <span style={{ color: "#475467" }}>{data.split(" ")[1]}</span>
                  </>
                }
              </>
            )
          },
        },
        {
          title: "Updated At (PST)",
          dataIndex: "pix_updatedAt",
          width: 150,
          onHeaderCell: () => ({
            className: 'table_diff_colors',
          }),
          onCell: () => ({
            className: "table_diff_colors_td"
          }),
          key: "pix_updatedAt",
          sortDirections: ['ascend', 'descend', 'ascend'],
          sorter: true,
          hidden: !colvisApproved["pix_updatedAt"],
          render: (data, record) => {
            return (

              <div className='text_dark'>{utcToPst(data)}</div>

            )
          },
        },

      ]
    }] : []),

    {
      title: <span >
        Human
        {columnPartialDataHuman ?
          <Tooltip
            title={`Partial Data (${columnTimeDataHuman})`}
          >
            <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
          </Tooltip>
          :
          <Tooltip
            title={`Complete Data (${columnTimeDataHuman})`}
          >
            <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
          </Tooltip>
        }
      </span>,
      onHeaderCell: () => ({
        className: 'diff_border_line_clr table_diff_colors_two',
      }),
      hidden: !(
        // colvisAll.hs_impressions ||
        // colvisAll.hs_givtImpressions ||
        // colvisAll.hs_sivtImpressions ||
        colvisApproved.hs_ivtImpressions ||
        // colvisApproved.viewability ||
        colvisApproved.hs_discrep ||
        colvisApproved.human_updatedAt
      ),
      "children": [

        // {
        //   title:

        //     <>

        //       <span >
        //         Gross Ad Count
        //         {columnPartialDataHuman ?
        //           <Tooltip
        //             title={`Partial Data (${columnTimeDataHuman})`}
        //           >
        //             <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
        //           </Tooltip>
        //           :

        //           <Tooltip
        //             title={`Complete Data (${columnTimeDataHuman})`}
        //           >
        //             <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
        //           </Tooltip>
        //         }
        //       </span>


        //     </>,
        //   dataIndex: "hs_impressions",
        //   width: 170,
        //   key: "hs_impressions",
        //   onHeaderCell: () => ({
        //     className: 'border_right_0',
        //   }),
        //   sortDirections: ['ascend', 'descend', 'ascend'],
        //   sorter: true,
        //   hidden: !colvisAll["hs_impressions"],
        //   render: (data, record) => {
        //     return (
        //       <>
        //         {(data === "" || data === undefined || data === null) ?
        //           <>
        //             <div className='text_dark'>-</div>
        //           </>
        //           :
        //           <>
        //             {addCommasToNumber(data)}
        //           </>
        //         }
        //       </>
        //     )
        //   },
        // },
        // {
        //   title:
        //     <>

        //       <span >
        //         GIVT Ad Count
        //         {columnPartialDataHuman ?
        //           <Tooltip
        //             title={`Partial Data (${columnTimeDataHuman})`}
        //           >
        //             <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
        //           </Tooltip>

        //           :
        //           <Tooltip
        //             title={`Complete Data (${columnTimeDataHuman})`}
        //           >
        //             <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
        //           </Tooltip>
        //         }
        //       </span>


        //     </>,
        //   dataIndex: "hs_givtImpressions",
        //   width: 170,
        //   onHeaderCell: () => ({
        //     className: 'border_right_0',
        //   }),
        //   key: "hs_givtImpressions",
        //   sortDirections: ['ascend', 'descend', 'ascend'],
        //   sorter: true,
        //   hidden: !colvisAll["hs_givtImpressions"],
        //   render: (data, record) => {
        //     return (
        //       <>
        //         {(data === "" || data === undefined || data === null) ?
        //           <>
        //             <div className='text_dark'>-</div>
        //           </>
        //           :
        //           <>
        //             {addCommasToNumber(data)}  {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.hs_givtRate)}%)</span>}
        //           </>
        //         }
        //       </>
        //     )
        //   },
        // },
        // {
        //   title:
        //     <>

        //       <span >
        //         SIVT Ad Count
        //         {columnPartialDataHuman ?
        //           <Tooltip
        //             title={`Partial Data (${columnTimeDataHuman})`}
        //           >
        //             <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
        //           </Tooltip>
        //           :
        //           <Tooltip
        //             title={`Complete Data (${columnTimeDataHuman})`}
        //           >
        //             <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
        //           </Tooltip>
        //         }
        //       </span>


        //     </>,
        //   dataIndex: "hs_sivtImpressions",
        //   width: 170,
        //   key: "hs_sivtImpressions",
        //   onHeaderCell: () => ({
        //     className: 'border_right_0',
        //   }),
        //   sortDirections: ['ascend', 'descend', 'ascend'],
        //   sorter: true,
        //   hidden: !colvisAll["hs_sivtImpressions"],
        //   render: (data, record) => {
        //     return (
        //       <>
        //         {(data === "" || data === undefined || data === null) ?
        //           <>
        //             <div className='text_dark'>-</div>
        //           </>
        //           :
        //           <>
        //             {addCommasToNumber(data)}   {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.hs_sivtRate)}%)</span>}
        //           </>
        //         }
        //       </>
        //     )
        //   },
        // },
        {
          title: <>

            <span >
              IVT
              {/* {columnPartialDataHuman ?
                <Tooltip
                  title={`Partial Data (${columnTimeDataHuman})`}
                >
                  <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                </Tooltip>
                :
                <Tooltip
                  title={`Complete Data (${columnTimeDataHuman})`}
                >
                  <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                </Tooltip>
              } */}
            </span>


          </>,
          dataIndex: "hs_ivtImpressions",
          width: 160,
          onHeaderCell: () => ({
            className: 'border_right_0 table_diff_colors_two',
          }),
          onCell: () => ({
            className: "table_diff_colors_two_td"
          }),
          key: "hs_ivtImpressions",
          sortDirections: ['ascend', 'descend', 'ascend'],
          sorter: true,
          hidden: !colvisApproved["hs_ivtImpressions"],
          render: (data, record) => {
            return (
              <>
                {(data === "" || data === undefined || data === null) ?
                  <>
                    <div className='text_dark'>-</div>
                  </>
                  :
                  <>
                    {addCommasToNumber(data)} {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.hs_ivtRate)}%)</span>}
                  </>
                }
              </>
            )
          },
        },
        // {
        //     title:
        //         <>

        //             <span >
        //                 Net Viewability
        //                 {columnPartialData ?
        //                     <Tooltip
        //                         title={`Partial Data (${columnTimeData})`}
        //                     >
        //                         <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
        //                     </Tooltip>
        //                     :
        //                     <Tooltip
        //                         title={`Complete Data (${columnTimeData})`}
        //                     >
        //                         <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
        //                     </Tooltip>
        //                 }
        //             </span>



        //         </>,
        //     dataIndex: "viewability",
        //     width: 150,
        //     onHeaderCell: () => ({
        //         className: 'border_right_0',
        //     }),
        //     key: "viewability",
        //     sortDirections: ['ascend', 'descend', 'ascend'],
        //     sorter: true,
        //     hidden: !colvisAll["viewability"],
        //     render: (data, record) => {
        //         return (
        //             <>
        //                 {(data === "" || data === undefined || data === null) ?
        //                     <>
        //                         <div className='text_dark'>-</div>
        //                     </>
        //                     :
        //                     <>
        //                         {addCommasToNumber(data)} %
        //                     </>
        //                 }
        //             </>
        //         )
        //     },
        // },
        {
          title:
            <>

              <span >
                Discrepancies
                {/* {columnPartialDataHuman ?
                  <Tooltip
                    title={`Partial Data (${columnTimeDataHuman})`}
                  >
                    <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                  </Tooltip>

                  :
                  <Tooltip
                    title={`Complete Data (${columnTimeDataHuman})`}
                  >
                    <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
                  </Tooltip>
                } */}
              </span>

            </>,
          dataIndex: "hs_discrep",
          width: 150,
          key: "hs_discrep",
          onHeaderCell: () => ({
            className: 'border_right_0 table_diff_colors_two',
          }),
          onCell: () => ({
            className: "table_diff_colors_two_td"
          }),
          sortDirections: ['ascend', 'descend', 'ascend'],
          sorter: true,
          hidden: !colvisApproved["hs_discrep"],
          render: (data, record) => {
            return (
              <>
                {(data === "" || data === undefined || data === null) ?
                  <>
                    <div className='text_dark'>-</div>
                  </>
                  :
                  <>
                    <span style={{ color: data.split(" ")[0] === "Low" ? "#0C875E" : data.split(" ")[0] === "High" ? "#FF0000" : "#EBB200" }}>{data.split(" ")[0]}</span> <span style={{ color: "#475467" }}>{data.split(" ")[1]}</span>
                  </>
                }
              </>
            )
          },
        },
        {
          title: "Updated At (PST)",
          dataIndex: "human_updatedAt",
          width: 150,
          onHeaderCell: () => ({
            className: 'table_diff_colors_two',
          }),
          onCell: () => ({
            className: "table_diff_colors_two_td"
          }),
          key: "human_updatedAt",
          sortDirections: ['ascend', 'descend', 'ascend'],
          sorter: true,
          hidden: !colvisApproved["human_updatedAt"],
          render: (data, record) => {
            return (

              <div className='text_dark'>{utcToPst(data)}</div>

            )
          },
        },

      ]
    },

    {
      title: <span >
        Double Verify
        {columnPartialDataDV ?
          <Tooltip
            title={`Partial Data (${columnTimeDataDV})`}
          >
            <img src={partialDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
          </Tooltip>
          :
          <Tooltip
            title={`Complete Data (${columnTimeDataDV})`}
          >
            <img src={timeDataIcon} alt="" style={{ paddingLeft: "4px", transform: "translateY(-1px)" }} />
          </Tooltip>
        }
      </span>,
      onHeaderCell: () => ({
        className: 'diff_border_line_clr table_diff_colors',
      }),
      onCell: () => ({
        className: "table_diff_colors_td"
      }),
      hidden: !(
        colvisApproved.dv_ivtImpressions ||
        colvisApproved.dv_discrep ||
        colvisApproved.dv_updatedAt
      ),
      "children": [

        {
          title: <>
            <span >
              IVT
            </span>
          </>,
          dataIndex: "dv_ivtImpressions",
          width: 160,
          onHeaderCell: () => ({
            className: 'border_right_0 table_diff_colors',
          }),
          onCell: () => ({
            className: "table_diff_colors_td"
          }),
          key: "dv_ivtImpressions",
          sortDirections: ['ascend', 'descend', 'ascend'],
          sorter: true,
          hidden: !colvisApproved["dv_ivtImpressions"],
          render: (data, record) => {
            return (
              <>
                {(data === "" || data === undefined || data === null) ?
                  <>
                    <div className='text_dark'>-</div>
                  </>
                  :
                  <>
                    {addCommasToNumber(data)} {data !== "0" && <span style={{ color: "#475467" }}>({addCommasToNumber(record.dv_ivtRate)}%)</span>}
                  </>
                }
              </>
            )
          },
        },
        {
          title:
            <>
              <span >
                Discrepancies
              </span>
            </>,
          dataIndex: "dv_discrep",
          width: 150,
          key: "dv_discrep",
          onHeaderCell: () => ({
            className: 'border_right_0 table_diff_colors',
          }),
          onCell: () => ({
            className: "table_diff_colors_td"
          }),
          sortDirections: ['ascend', 'descend', 'ascend'],
          sorter: true,
          hidden: !colvisApproved["dv_discrep"],
          render: (data, record) => {
            return (
              <>
                {(data === "" || data === undefined || data === null) ?
                  <>
                    <div className='text_dark'>-</div>
                  </>
                  :
                  <>
                    <span style={{ color: data.split(" ")[0] === "Low" ? "#0C875E" : data.split(" ")[0] === "High" ? "#FF0000" : "#EBB200" }}>{data.split(" ")[0]}</span> <span style={{ color: "#475467" }}>{data.split(" ")[1]}</span>
                  </>
                }
              </>
            )
          },
        },
        {
          title: "Updated At (PST)",
          dataIndex: "dv_updatedAt",
          width: 150,
          onHeaderCell: () => ({
            className: 'table_diff_colors',
          }),
          onCell: () => ({
            className: "table_diff_colors_td"
          }),
          key: "dv_updatedAt",
          sortDirections: ['ascend', 'descend', 'ascend'],
          sorter: true,
          hidden: !colvisApproved["dv_updatedAt"],
          render: (data, record) => {
            return (

              <div className='text_dark'>{utcToPst(data)}</div>

            )
          },
        },

      ]
    },

    {
      title: "Check In",
      key: "checkIn",
      // fixed: 'right',
      onHeaderCell: () => ({
        className: 'border-0',
      }),
      width: 80,
      // hidden: !(checkRole === "sa" || checkRole === "mobops"),
      render: (_, record) => (
        <div className='download_icon download_icon_d2'
          onClick={() => {
            setIsCheckinUserVisible(true)
            setCheckinUser(record)
          }
          }

        >
          <Tooltip title="Check In">
            <img src={CheckInIcon} className='img-fluid cursor_pointer' />
          </Tooltip>
        </div >
      ),
    },


  ];

  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [initialLoad, setInitialLoad] = useState(true)
  const [tabLoad, setTabLoad] = useState(false)

  const [accountManagerOptions, setAccountManagerOptions] = useState([])


  const [page, setPage] = useState({
    current: 1,
    pageSize: 50,
    total: 10,
  });

  const [sort, setSort] = useState({
    name: "",
    type: ""
  });

  const [search, setSearch] = useState("")
  const [filter, setFilter] = useState("all")
  const getDataAbortRef = useRef(null)

  const getData = () => {
    // setLoading(true)
    let status = Cookies.get("token_xapads_ssp") ? true : false;
    if (status) {
      let token = Cookies.get("token_xapads_ssp");
      let checkRoleFilter = jwtDecode(token)?.role

      if (getDataAbortRef.current) {
        getDataAbortRef.current.abort();
      }
      getDataAbortRef.current = new AbortController();

      axios
        .get(configData.SERVER_URL + `ops/pubList?sort=${sort.name}&order=${sort.type}&search=${search}&limit=${page.pageSize}&page=${page.current}&filter=${checkRoleFilter === "am" ? "approved" : filter}`, {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
          signal: getDataAbortRef.current.signal,
        })
        .then((response) => {
          setData(response.data.data.data)
          if (response.data.data.data.length > 0) {
            let tempPage = { ...page }
            tempPage.total = response.data.data.metaData?.totalRecords

            setPage(tempPage)
          }

          // setTimeout(() => {
          //   setLoading(false)
          // }, 300)

          // PIXALATE SUNSET: Pixalate metrics no longer returned by API
          // setColumnPartialData(response.data.partial)
          // setColumnTimeData(response.data.pix_updatedAt)
          setColumnPartialDataHuman(response.data.hs_partial)
          setColumnTimeDataHuman(response.data.hs_date || "-")
          setColumnPartialDataDV(response.data.dv_partial)
          setColumnTimeDataDV(response.data.dv_date || "-")

          setLoading(false)
          setTabLoad(false)
          setInitialLoad(false)
        })
        .catch((error) => {
          if (axios.isCancel(error)) return;

          setData([])

          setColumnPartialData(false)
          setColumnTimeData("")
          setColumnPartialDataHuman(false)
          setColumnTimeDataHuman("")
          setColumnPartialDataDV(false)
          setColumnTimeDataDV("")

          setLoading(false)
          setTabLoad(false)
          setInitialLoad(false)
        });
    }

  }

  // Function to convert JSON to CSV
  const convertToCSV = (data, headers) => {
    const csvRows = [];
    // Create header row
    const headerRow = headers.map(header => header.label).join(",");
    csvRows.push(headerRow);
    // Create data rows
    data.forEach(row => {
      const rowData = headers.map(header => {
        let value = row[header.key] ?? ""; // Use empty string if value is undefined/null
        if (header.key === "IM") {
          if (Object.keys(value).length > 0) {
            value = `${value.label} (${value.value})`
          }

        }

        // if (header.key === "Phone Number") {
        //   if (value !== undefined) {
        //     value = value?.replace("-", "")
        //   }
        // }

        if (header.key === "givtImpressions") {
          const givtImpsRate = row["givtImpsRate"] ?? 0; // Default to 0 if undefined
          if (value !== "0") {
            value = `${value} (${givtImpsRate}%)`;
          }
        }

        if (header.key === "sivtImpressions") {
          const sivtImpsRate = row["sivtImpsRate"] ?? 0; // Default to 0 if undefined
          if (value !== "0") {
            value = `${value} (${sivtImpsRate}%)`;
          }
        }

        if (header.key === "givtSivtImp") {
          const givtSivtRate = row["givtSivtRate"] ?? 0; // Default to 0 if undefined
          if (value !== "0") {
            value = `${value} (${givtSivtRate}%)`;
          }
        }

        if (header.key === "viewability") {
          if (value !== undefined) {
            value = `${value}% `
          }
        }

        if (header.key === "AM") {
          if (value !== undefined) {
            if (value.length > 0) {
              value = value.join(",")
            }
            else {
              value = ""
            }

          }
        }

        if (header.key === "Country") {
          value = row["countryName"]
        }

        return `"${String(value).replace(/"/g, '""')}"`; // Escape double quotes
      });
      csvRows.push(rowData.join(","));
    });
    return csvRows.join("\n");
  };

  const transformCellValue = (row, header) => {
    let value = row[header.key] ?? ""; // default to empty string

    if (header.key === "AM") {
      if (value !== undefined) {
        if (value.length > 0) {
          value = value.join(",")
        }
        else {
          value = ""
        }

      }
    }

    if (header.key === "IM") {
      if (Object.keys(value).length > 0) {
        value = `${value.label} (${value.value})`
      }

    }

    if (header.key === "Country") {
      value = row["countryName"]
    }

    if (header.key === "givtImpressions") {
      const givtImpsRate = row["givtImpsRate"] ?? 0;
      if (value !== "0") {
        value = `${value} (${givtImpsRate}%)`;
      }
    }

    if (header.key === "hs_givtImpressions") {
      const givtImpsRate1 = row["hs_givtRate"] ?? 0;
      if (value !== "0") {
        value = `${value} (${givtImpsRate1}%)`;
      }
    }

    if (header.key === "sivtImpressions") {
      const sivtImpsRate = row["sivtImpsRate"] ?? 0;
      if (value !== "0") {
        value = `${value} (${sivtImpsRate}%)`;
      }
    }

    if (header.key === "hs_sivtImpressions") {
      const sivtImpsRate1 = row["hs_sivtRate"] ?? 0;
      if (value !== "0") {
        value = `${value} (${sivtImpsRate1}%)`;
      }
    }

    if (header.key === "givtSivtImp") {
      const givtSivtRate = row["givtSivtRate"] ?? 0;
      if (value !== "0") {
        value = `${value} (${givtSivtRate}%)`;
      }
    }


    if (header.key === "hs_ivtImpressions") {
      const givtSivtRate1 = row["hs_ivtRate"] ?? 0;
      if (value !== "0") {
        value = `${value} (${givtSivtRate1}%)`;
      }
    }

    if (header.key === "viewability") {
      if (value !== undefined && value !== "") {
        value = `${value}%`;
      }
    }

    return value;
  };

  const getDataExport = () => {
    setExportLoading(true)
    let status = Cookies.get("token_xapads_ssp") ? true : false;
    if (status) {
      let token = Cookies.get("token_xapads_ssp");
      axios
        .get(configData.SERVER_URL + `ops/pubList?sort=${sort.name}&order=${sort.type}&search=${search}&limit=100000&page=1&filter=all`, {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
        })
        .then((response) => {
          const data = response.data.data.data;
          const keptArray = exportHeader.filter(item => colvisAll[item.key] !== false);
          const wsData = [];

          // 🔹 First row (groups)
          const groupRow = keptArray.map((h) => h.group || "");
          wsData.push(groupRow);

          // 🔹 Second row (labels)
          const headerRow = keptArray.map((h) => h.label);
          wsData.push(headerRow);

          // 🔹 Data rows with transformations
          data.forEach((row) => {
            wsData.push(keptArray.map((h) => transformCellValue(row, h)));
          });

          // Convert to worksheet
          const ws = XLSX.utils.aoa_to_sheet(wsData);

          // 🔹 Merge group cells
          let currentGroup = null;
          let startCol = 0;

          keptArray.forEach((h, i) => {
            if (h.group) {
              if (currentGroup !== h.group) {
                if (currentGroup) {
                  ws["!merges"] = ws["!merges"] || [];
                  ws["!merges"].push({ s: { r: 0, c: startCol }, e: { r: 0, c: i - 1 } });
                }
                currentGroup = h.group;
                startCol = i;
              }
            } else {
              if (currentGroup) {
                ws["!merges"] = ws["!merges"] || [];
                ws["!merges"].push({ s: { r: 0, c: startCol }, e: { r: 0, c: i - 1 } });
                currentGroup = null;
              }
            }
          });

          // Merge last group
          if (currentGroup) {
            ws["!merges"] = ws["!merges"] || [];
            ws["!merges"].push({
              s: { r: 0, c: startCol },
              e: { r: 0, c: keptArray.length - 1 },
            });
          }

          // Create workbook
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Zones");

          // Export as Excel
          const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
          saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            "Publishers_" + new Date().getTime() + ".xlsx"
          );
          // saveAs(blob, "Publishers_" + new Date().getTime() + ".csv");
          setExportLoading(false)
        })
        .catch((error) => {
          notifyfailure("Failed to export zone list");
          setExportLoading(false)
        });
    }
  }



  useEffect(() => {
    TokenVerificationLoggedin();
    BlockAdmin()
    // getData()

    let status = Cookies.get("token_xapads_ssp") ? true : false;
    if (status) {
      let token = Cookies.get("token_xapads_ssp");
      if (token) {
        setCheckRole(jwtDecode(token)?.role);
        if (jwtDecode(token)?.role === "am") {
          setFilter("approved")
        }

      }
    }

    loadingContext.done()
  }, [loadingContext]);

  useEffect(() => {
    axios
      .get(configData.SERVER_URL + "ops/p_manager", {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setAccountManagerOptions(response.data.data);
      })
      .catch((error) => { });
  }, [])

  useEffect(() => {
    // if (!initialLoad) {
    getData()
    // }
  }, [apiCall])

  useEffect(() => {
    if (!initialLoad) {
      const delayDebounceFn = setTimeout(() => {
        setLoading(true)
        let tempPage = page
        tempPage.current = 1
        setPage(tempPage);
        setApicall(!apiCall)
      }, 400); // 500ms delay
      // Cleanup function to clear the timeout if query changes
      return () => clearTimeout(delayDebounceFn);
    }
  }, [search]);


  function handleTabChange(event) {
    let data = event.target.value
    if (filter !== event.target.value) {
      setTabLoad(true)
    }
    setFilter(data)
    let tempPage = page
    tempPage.current = 1
    tempPage.total = 10
    setPage(tempPage)

    // setPage({
    //   current: 1,
    //   pageSize: 10,
    //   total: 10,
    // })
    setSearch("")
    setSort({
      name: "",
      type: ""
    })

    resetSorter()

    setApicall(!apiCall)



    // if(data==="all"){
    //   setTableColumns(columnsAll)
    // }
    // else if(data==="new"){
    //   setTableColumns(columnsNew)
    // }
    // else if(data==="onboard"){
    //   setTableColumns(columnsOnboard)
    // }
    // else if(data==="approved"){
    //   setTableColumns(columnsApproved)
    // }


  }

  const resetSorter = () => {
    setTimeout(() => {
      document.querySelectorAll('th[aria-sort]').forEach(th => {
        th.removeAttribute('aria-sort');
      });

      document.querySelectorAll('span[aria-label="caret-up"]').forEach(span => {
        span.classList.remove('active');
      });

      document.querySelectorAll('span[aria-label="caret-down"]').forEach(span => {
        span.classList.remove('active');
      });

    }, 0);

  };

  const handleAniviewIdCreate = (record) => {
    setData(prevData =>
      prevData.map(obj => {
        if (obj["ADK ID"] === record["ADK ID"]) {
          return { ...obj, aniviewLoading: true };
        }
        return obj;
      })
    );

    let status = Cookies.get("token_xapads_ssp") ? true : false;
    if (status) {
      let token = Cookies.get("token_xapads_ssp")

      axios
        .post(configData.SERVER_URL + "ops/createAniviewPub?_id=" + record._id, {},
          {
            headers: {
              "Content-Type": "application/json",
              "x-access-token": token,
            },
          }
        )
        .then((response) => {

          notifysuccess(response.data.message)
          setData(prevData =>
            prevData.map(obj => {
              if (obj["ADK ID"] === record["ADK ID"]) {
                const { aniviewLoading, ...rest } = obj; // Destructure to exclude `aniviewLoading`
                return { ...rest, "Aniview ID": response.data.data };
              }
              return obj;
            })
          );

        })
        .catch((error) => {
          if (error?.response) {
            if (error?.response?.data?.message?.length !== 0) {
              notifyfailure(error.response.data.message)
            }
          } else {
            notifycatch()
          }

          setData(prevData =>
            prevData.map(obj => {
              if (obj["ADK ID"] === record["ADK ID"]) {
                const { aniviewLoading, ...rest } = obj; // Destructure to exclude `aniviewLoading`
                return rest
              }
              return obj;
            })
          );

        });
    }

  }

  const handleTableChange = (pagination, filters, sorter) => {
    // const pager = { ...page };
    // pager.current = pagination.current;
    // setPage(pager);
    // let order;
    // if (sort.name === sorter.field) {
    //   order = sort.type === 'ascend' ? 'descend' : 'ascend';
    // } else {
    //   order = 'ascend';
    // }
    setSort({ name: sorter.field, type: sorter.order });
    // fetchData({
    //   sortField: sorter.field,
    //   sortOrder: sorter.order,
    //   pagination: pager,
    //   ...filters,
    // });
    setApicall(!apiCall)
    setLoading(true)
  };

  const fetchAndDownloadFiles = async (urls) => {

    let name = 1

    try {
      const zip = new JSZip();
      const promises = urls.map(async (ob, index) => {
        try {
          // const response = await fetch(ob?.url);
          const response = await fetch("https://unified-supply-platform.s3.ap-south-1.amazonaws.com/mediaKit/1720698869515-file_example_PPT_1MB.ppt")


          if (!response.ok) {
            throw new Error(`Failed to fetch ${ob?.url}: ${response.statusText}`);
          }
          const blob = await response.blob();

          // Assuming the filename is extracted from the URL or provided in some way
          // const filename = name +"."+ response.headers.get("Content-type").split("/")[1] ;
          // name++;

          zip.file(ob.fileName + "." + ob?.ext, blob);
        } catch (error) {
          console.error("Error fetching file:", error);
        }
      });

      await Promise.all(promises);

      const zipBlob = await zip.generateAsync({ type: "blob" });
      FileSaver.saveAs(zipBlob, "attachments.zip");
      // setIsLoadingInner(false);
      notifysuccess("Media kit downloaded successfully");
    } catch (error) {
      notifyfailure("Error while fetching the media kit.");
      // setIsLoadingInner(false);
    }
  };


  function statusChange(statusFlag, id, approveFlag) {


    let status = Cookies.get("token_xapads_ssp") ? true : false;
    if (status) {
      let token = Cookies.get("token_xapads_ssp");

      let payload = {
        "status": statusFlag,
        "_id": id,
        "approvedOnce": approveFlag
      }

      setLoading(true)
      axios
        .post(configData.SERVER_URL + `ops/statusUpdate`, payload, {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
        })
        .then((response) => {
          setApicall(!apiCall)
          notifysuccess(response.data.message);

        })
        .catch((error) => {
          if (error.response.data.message?.length !== 0) {
            notifyfailure(error.response.data.message)
          }
          else {
            notifycatch()
          }
          setLoading(false)

        });

    }
  }

  const handlePageView = (data) => {
    setPageView(data)

  }

  const handlePageViewForEdit = (data, reload) => {
    if (reload === "yes") {
      setApicall(!apiCall)
    }
    setPublisherViewId("")
    setPublisherViewName("")
    setAccountStatus("")
    setPageView(data)
  }


  const handlePageChange = (data) => {

    let tempPage = page
    tempPage.current = data
    setPage(tempPage);
    setApicall(!apiCall)
    setLoading(true)
  };

  const handlePageSizeChange = (e) => {
    let tempPage = page
    tempPage.pageSize = e

    if (tempPage.current > 1) {
      if (e * tempPage.current > tempPage.total) {
        tempPage.current = 1
      }
    }
    setPage(tempPage);
    setApicall(!apiCall)
    setLoading(true)
  };

  const itemRender = (current, type, originalElement) => {
    if (type === 'prev') {
      return <Link><img src={prevIcon} alt='USP' /></Link>;
    }
    if (type === 'next') {
      return <Link><img src={nextIcon} alt='USP' /></Link>;
    }
    return originalElement;
  };


  const locale = {
    emptyText:
      <>{search.trim().length > 0 && loading ?
        <div className='no_data_screen'>
          <div className='text-center'>
            {/* <img src={errorData} className='' alt="" /> */}
            <div className='float_text_div'>
              {/* <h1 className='no_data_heading'>Sorry! No result found :(</h1>
               <p className='no_data_para'>Please check the spelling or try searching for something else. </p> */}
            </div>
          </div>
        </div>
        :
        search.trim().length > 0 && !loading ?
          <div className='no_data_screen'>
            <div className='text-center'>
              <img src={errorData} className='' alt="" />
              <div className='float_text_div'>
                {/* <h1 className='no_data_heading'>Sorry! No result found :(</h1>
                <p className='no_data_para'>Please check the spelling or try searching for something else. </p> */}
              </div>
            </div>
          </div>
          :

          loading ?
            <div className='no_data_screen'>
              <div className='text-center'>
                {/* <img src={errorData} className='' alt="" /> */}
                <div className='float_text_div'>
                  {/* <h1 className='no_data_heading'>Sorry! No result found :(</h1>
                  <p className='no_data_para'>Please check the spelling or try searching for something else. </p> */}
                </div>
              </div>
            </div>
            :
            <div className='no_data_screen' >
              <div className='text-center'>
                <img src={noData} className='' alt="" />
                <div className='float_text_div'>
                  {/* <h1 className='no_data_heading'>Whoops! Looks like there’s no data.</h1>
                  <p className='no_data_para'>There are no records to show you right <br /> now.</p> */}
                </div>
              </div>
            </div>
      }
      </>

  };

  const components = {
    header: {
      wrapper: (props) => (
        <thead {...props}>
          {/* <tr>
                    <th colSpan={columnsAll.length} style={{ textAlign: 'center', background: '#fafafa' }}>
                        Custom Header
                    </th>
                </tr> */}
          {props.children}
        </thead>
      ),
    },

    body: {
      wrapper: (props) => (
        <tbody {...props}>
          {loading ? (
            <>
              <div className='loader_top_space'>
                <div className="inside_table_two_loader">
                  {/* <ContentLoader
                  speed={1}
                  width={1750}
                  height={156}
                  viewBox="-20 0 1806 156"
                  backgroundColor="#f3f3f3"
                  foregroundColor="#e8ecf2"
                >
                  <rect x="0" y="0" rx="6" ry="6" width="85" height="12" />
                  <rect x="1132" y="0" rx="6" ry="6" width="76" height="12" />
                  <rect x="955" y="0" rx="6" ry="6" width="76" height="12" />
                  <rect x="1272" y="0" rx="6" ry="6" width="76" height="12" />
                  <rect x="1411" y="0" rx="6" ry="6" width="76" height="12" />
                  <rect x="1552" y="0" rx="6" ry="6" width="76" height="12" />
                  <rect x="1692" y="0" rx="6" ry="6" width="114" height="12" />
                  <rect x="152" y="0" rx="6" ry="6" width="271" height="12" />
                  <rect x="539" y="0" rx="6" ry="6" width="271" height="12" />
                  <rect x="0" y="48" rx="6" ry="6" width="85" height="12" />
                  <rect x="1132" y="48" rx="6" ry="6" width="76" height="12" />
                  <rect x="955" y="48" rx="6" ry="6" width="76" height="12" />
                  <rect x="1272" y="48" rx="6" ry="6" width="76" height="12" />
                  <rect x="1411" y="48" rx="6" ry="6" width="76" height="12" />
                  <rect x="1552" y="48" rx="6" ry="6" width="76" height="12" />
                  <rect x="1692" y="48" rx="6" ry="6" width="114" height="12" />
                  <rect x="152" y="48" rx="6" ry="6" width="271" height="12" />
                  <rect x="539" y="48" rx="6" ry="6" width="271" height="12" />
                  <rect x="0" y="96" rx="6" ry="6" width="85" height="12" />
                  <rect x="1132" y="96" rx="6" ry="6" width="76" height="12" />
                  <rect x="955" y="96" rx="6" ry="6" width="76" height="12" />
                  <rect x="1272" y="96" rx="6" ry="6" width="76" height="12" />
                  <rect x="1411" y="96" rx="6" ry="6" width="76" height="12" />
                  <rect x="1552" y="96" rx="6" ry="6" width="76" height="12" />
                  <rect x="1692" y="96" rx="6" ry="6" width="114" height="12" />
                  <rect x="152" y="96" rx="6" ry="6" width="271" height="12" />
                  <rect x="539" y="96" rx="6" ry="6" width="271" height="12" />
                  <rect x="0" y="144" rx="6" ry="6" width="85" height="12" />
                  <rect x="1132" y="144" rx="6" ry="6" width="76" height="12" />
                  <rect x="955" y="144" rx="6" ry="6" width="76" height="12" />
                  <rect x="1272" y="144" rx="6" ry="6" width="76" height="12" />
                  <rect x="1411" y="144" rx="6" ry="6" width="76" height="12" />
                  <rect x="1552" y="144" rx="6" ry="6" width="76" height="12" />
                  <rect x="1692" y="144" rx="6" ry="6" width="114" height="12" />
                  <rect x="152" y="144" rx="6" ry="6" width="271" height="12" />
                  <rect x="539" y="144" rx="6" ry="6" width="271" height="12" />
                </ContentLoader> */}
                  <img src={FullLoader} className="" alt="" />
                </div>
              </div>


            </>
          ) : (
            props.children
          )}
        </tbody>
      ),
    },
  };





  return (
    <>

      <div className="container_box--wrapper pt_header"
        style={{ opacity: pageView === "table" ? 1 : 0, display: pageView === "table" ? "block" : "none" }}
      >
        <div className="container_box--wrapper--title d_flex justify-content-between">
          <h1 className="heading fw_600"> Publishers </h1>
          {/* 
          {!initialLoad &&
            <button className='btn btn_primary w_fit_content md'
              onClick={() => { setPageView("import") }}
            ><span><img src={importIcon} alt='USP' /> Import</span></button>
          } */}

        </div>
        <div className="d_flex justify_content_between w_100 mb_10">
          {!initialLoad &&
            <div className="">
              {checkRole !== "am" &&
                <div className="radios_btns --radios_btns_new">
                  <Radio.Group
                    className='radio_btn--group mb-0'
                    value={filter}
                    onChange={handleTabChange}>
                    <Radio.Button value="all">All
                      {/* <small className="tabs_number_div"> 100</small> */}
                    </Radio.Button>
                    <Radio.Button value="new">New
                      {/* <small className="tabs_number_div"> 100</small> */}
                    </Radio.Button>
                    <Radio.Button value="onboard">Onboarded
                      {/* <small className="tabs_number_div"> 100</small> */}
                    </Radio.Button>
                    <Radio.Button value="rejected">Rejected
                      {/* <small className="tabs_number_div"> 100</small> */}
                    </Radio.Button>
                    <Radio.Button value="approved">Approved
                      {/* <small className="tabs_number_div"> 100</small> */}
                    </Radio.Button>
                    <Radio.Button value="declined">Declined
                      {/* <small className="tabs_number_div"> 100</small> */}
                    </Radio.Button>
                    <Radio.Button value="archived">Archived
                      {/* <small className="tabs_number_div"> 100</small> */}
                    </Radio.Button>
                  </Radio.Group>
                </div>
              }
              {/* {checkRole === "am" &&
                <Input
                  type='text'
                  className='form_control basic md search_input w_table_search'
                  placeholder="Search"
                  value={search}
                  onChange={(e) => {
                    if (e.target.value.trim().length === 0) {
                      setLoading(true)
                    }
                    setSearch(e.target.value)
                  }
                  }
                />} */}
            </div>
          }


        </div>

        <div className={data.length > 0 ? "table_and_filter_div --without_filter_div" : "table_and_filter_div --without_filter_div --no_data_div_height_with_tabs"}>
          <div className="table_area_div">
            <div className="searchbar_with_btns">
              <div className="d-flex align-items-center justify-content-between">

                {/* {checkRole !== "am" && */}
                <div className="form_content_block--group w-50 mb-0">
                  {!initialLoad &&

                    <Input
                      type='text'
                      className='form_control basic md search_input w_table_search'
                      placeholder="Search"
                      value={search}
                      onChange={(e) => {
                        if (e.target.value.trim().length === 0) {
                          setLoading(true)
                        }
                        setSearch(e.target.value)
                      }
                      }
                    />
                  }
                </div>
                {/* } */}

                {!initialLoad &&
                  <div className="custom_filter_design_d2 justify-content-end --new_layout_design_btn">
                    {filter === "all" &&
                      <div className="export_btn_hover_d2">
                        {data.length === 0 ?
                          <Button
                            className="export_btn_d2" icon={
                              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <g clip-path="url(#clip0_11006_24214)">
                                  <path d="M12.25 8.75V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V8.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M4.08423 5.83325L7.0009 8.74992L9.91756 5.83325" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M7 8.75V1.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_11006_24214">
                                    <rect width="14" height="14" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            }>
                            Export
                          </Button>
                          :
                          <>
                            {exportLoading ?
                              <Button
                                className="export_btn_d2"
                                loading
                                disabled
                                icon={
                                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <g clip-path="url(#clip0_11006_24214)">
                                      <path d="M12.25 8.75V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V8.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M4.08423 5.83325L7.0009 8.74992L9.91756 5.83325" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M7 8.75V1.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_11006_24214">
                                        <rect width="14" height="14" fill="white" />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                }>
                                Export
                              </Button>
                              :
                              <Button
                                className="export_btn_d2"
                                onClick={getDataExport}
                                icon={
                                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <g clip-path="url(#clip0_11006_24214)">
                                      <path d="M12.25 8.75V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V8.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M4.08423 5.83325L7.0009 8.74992L9.91756 5.83325" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                      <path d="M7 8.75V1.75" stroke="#1E293B" stroke-width="1.54" stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_11006_24214">
                                        <rect width="14" height="14" fill="white" />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                }>
                                Export
                              </Button>
                            }
                          </>
                        }
                      </div>
                    }
                    <div className="column_hide_unhide_d3 column_hide_unhide_mediaplanner_d2">
                      <Dropdown className="" autoClose="outside">
                        <Dropdown.Toggle id="dropdown-autoclose-outside">
                          <Button className="" icon={
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                              <path d="M1.5 3H5.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M8.5 3H12.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M1.5 7H5.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M8.5 7H12.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M1.5 11H5.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                              <path d="M8.5 11H12.5" stroke="#1E293B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                          }>
                            Columns
                          </Button>
                        </Dropdown.Toggle>

                        {filter === "all" ?
                          <Dropdown.Menu>
                            <div className="colunm_checkbox">
                              <ul className="p-0 m-0"

                              >
                                <li
                                >
                                  <label htmlFor="select_all_adcodes">
                                    <input
                                      className={isIndeterminate(colvisAll) ? "form-check-input parital_checkbox" : "form-check-input"}
                                      type="checkbox"
                                      id="select_all_adcodes"
                                      checked={Object.values(colvisAll).every(value => value === true)}
                                      onChange={(e) => {
                                        const updatedObj = Object.keys(colvisAll).reduce((acc, key) => {
                                          acc[key] = e.target.checked;
                                          return acc;
                                        }, {});

                                        setColvisAll(updatedObj);
                                      }}
                                    />
                                    <span>
                                      < >Select All</>
                                    </span>
                                  </label>
                                </li>
                                <hr className="new_item_line_d3" />

                              </ul>
                              <ul
                                className="p-0 m-0 colvis_scroll"
                              >
                                <Row >
                                  {filterRepeaterValueOptions_colvisAll.map(({ label, value }) => (
                                    <Col span={8}>
                                      <li key={value}>
                                        <label htmlFor={value}>
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id={value}
                                            checked={colvisAll[value]}
                                            onChange={() => {
                                              const tempData = { ...colvisAll };
                                              tempData[value] = !tempData[value];
                                              setColvisAll(tempData);
                                            }}
                                          />
                                          <span> {label?.length >= 50 ?
                                            <Tooltip title={label}>< >{label?.slice(0, 50)}...</></Tooltip> :
                                            < >{label}</>}
                                          </span>
                                        </label>
                                      </li>
                                    </Col>
                                  ))}


                                </Row>



                              </ul>
                            </div>

                          </Dropdown.Menu>
                          :
                          filter === "new" ?
                            <Dropdown.Menu>
                              <div className="colunm_checkbox">
                                <ul className="p-0 m-0"

                                >
                                  <li
                                  >
                                    <label htmlFor="select_all_adcodes">
                                      <input
                                        className={isIndeterminate(colvisNew) ? "form-check-input parital_checkbox" : "form-check-input"}
                                        type="checkbox"
                                        id="select_all_adcodes"
                                        checked={Object.values(colvisNew).every(value => value === true)}
                                        onChange={(e) => {
                                          const updatedObj = Object.keys(colvisNew).reduce((acc, key) => {
                                            acc[key] = e.target.checked;
                                            return acc;
                                          }, {});

                                          setColvisNew(updatedObj);
                                        }}
                                      />
                                      <span>
                                        < >Select All</>
                                      </span>
                                    </label>
                                  </li>
                                  <hr className="new_item_line_d3" />

                                </ul>
                                <ul
                                  className="p-0 m-0 colvis_scroll"
                                >
                                  <Row >
                                    {filterRepeaterValueOptions_colvisNew.map(({ label, value }) => (
                                      <Col span={8}>
                                        <li key={value}>
                                          <label htmlFor={value}>
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id={value}
                                              checked={colvisNew[value]}
                                              onChange={() => {
                                                const tempData = { ...colvisNew };
                                                tempData[value] = !tempData[value];
                                                setColvisNew(tempData);
                                              }}
                                            />
                                            <span> {label?.length >= 50 ?
                                              <Tooltip title={label}>< >{label?.slice(0, 50)}...</></Tooltip> :
                                              < >{label}</>}
                                            </span>
                                          </label>
                                        </li>
                                      </Col>
                                    ))}


                                  </Row>



                                </ul>
                              </div>

                            </Dropdown.Menu>
                            :
                            filter === "onboard" ?
                              <Dropdown.Menu>
                                <div className="colunm_checkbox">
                                  <ul className="p-0 m-0"

                                  >
                                    <li
                                    >
                                      <label htmlFor="select_all_adcodes">
                                        <input
                                          className={isIndeterminate(colvisOnboarded) ? "form-check-input parital_checkbox" : "form-check-input"}
                                          type="checkbox"
                                          id="select_all_adcodes"
                                          checked={Object.values(colvisOnboarded).every(value => value === true)}
                                          onChange={(e) => {
                                            const updatedObj = Object.keys(colvisOnboarded).reduce((acc, key) => {
                                              acc[key] = e.target.checked;
                                              return acc;
                                            }, {});

                                            setColvisOnboarded(updatedObj);
                                          }}
                                        />
                                        <span>
                                          < >Select All</>
                                        </span>
                                      </label>
                                    </li>
                                    <hr className="new_item_line_d3" />

                                  </ul>
                                  <ul
                                    className="p-0 m-0 colvis_scroll"
                                  >
                                    <Row >
                                      {filterRepeaterValueOptions_colvisOnboarded.map(({ label, value }) => (
                                        <Col span={8}>
                                          <li key={value}>
                                            <label htmlFor={value}>
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={value}
                                                checked={colvisOnboarded[value]}
                                                onChange={() => {
                                                  const tempData = { ...colvisOnboarded };
                                                  tempData[value] = !tempData[value];
                                                  setColvisOnboarded(tempData);
                                                }}
                                              />
                                              <span> {label?.length >= 50 ?
                                                <Tooltip title={label}>< >{label?.slice(0, 50)}...</></Tooltip> :
                                                < >{label}</>}
                                              </span>
                                            </label>
                                          </li>
                                        </Col>
                                      ))}


                                    </Row>



                                  </ul>
                                </div>

                              </Dropdown.Menu>
                              :
                              filter === "rejected" ?
                                <Dropdown.Menu>
                                  <div className="colunm_checkbox">
                                    <ul className="p-0 m-0"

                                    >
                                      <li
                                      >
                                        <label htmlFor="select_all_adcodes">
                                          <input
                                            className={isIndeterminate(colvisRejected) ? "form-check-input parital_checkbox" : "form-check-input"}
                                            type="checkbox"
                                            id="select_all_adcodes"
                                            checked={Object.values(colvisRejected).every(value => value === true)}
                                            onChange={(e) => {
                                              const updatedObj = Object.keys(colvisRejected).reduce((acc, key) => {
                                                acc[key] = e.target.checked;
                                                return acc;
                                              }, {});

                                              setColvisRejected(updatedObj);
                                            }}
                                          />
                                          <span>
                                            < >Select All</>
                                          </span>
                                        </label>
                                      </li>
                                      <hr className="new_item_line_d3" />

                                    </ul>
                                    <ul
                                      className="p-0 m-0 colvis_scroll"
                                    >
                                      <Row >
                                        {filterRepeaterValueOptions_colvisRejected.map(({ label, value }) => (
                                          <Col span={8}>
                                            <li key={value}>
                                              <label htmlFor={value}>
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  id={value}
                                                  checked={colvisRejected[value]}
                                                  onChange={() => {
                                                    const tempData = { ...colvisRejected };
                                                    tempData[value] = !tempData[value];
                                                    setColvisRejected(tempData);
                                                  }}
                                                />
                                                <span> {label?.length >= 50 ?
                                                  <Tooltip title={label}>< >{label?.slice(0, 50)}...</></Tooltip> :
                                                  < >{label}</>}
                                                </span>
                                              </label>
                                            </li>
                                          </Col>
                                        ))}


                                      </Row>



                                    </ul>
                                  </div>

                                </Dropdown.Menu>
                                :
                                filter === "archived" ?
                                  <Dropdown.Menu>
                                    <div className="colunm_checkbox">
                                      <ul className="p-0 m-0">
                                        <li>
                                          <label htmlFor="select_all_adcodes">
                                            <input
                                              className={isIndeterminate(colvisArchive) ? "form-check-input parital_checkbox" : "form-check-input"}
                                              type="checkbox"
                                              id="select_all_adcodes"
                                              checked={Object.values(colvisArchive).every(value => value === true)}
                                              onChange={(e) => {
                                                const updatedObj = Object.keys(colvisArchive).reduce((acc, key) => {
                                                  acc[key] = e.target.checked;
                                                  return acc;
                                                }, {});
                                                setColvisArchive(updatedObj);
                                              }}
                                            />
                                            <span>
                                              < >Select All</>
                                            </span>
                                          </label>
                                        </li>
                                        <hr className="new_item_line_d3" />
                                      </ul>
                                      <ul className="p-0 m-0 colvis_scroll">
                                        <Row>
                                          {filterRepeaterValueOptions_colvisArchive.map(({ label, value }) => (
                                            <Col span={8}>
                                              <li key={value}>
                                                <label htmlFor={value}>
                                                  <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id={value}
                                                    checked={colvisArchive[value]}
                                                    onChange={() => {
                                                      const tempData = { ...colvisArchive };
                                                      tempData[value] = !tempData[value];
                                                      setColvisArchive(tempData);
                                                    }}
                                                  />
                                                  <span> {label?.length >= 50 ?
                                                    <Tooltip title={label}>< >{label?.slice(0, 50)}...</></Tooltip> :
                                                    < >{label}</>}
                                                  </span>
                                                </label>
                                              </li>
                                            </Col>
                                          ))}
                                        </Row>
                                      </ul>
                                    </div>
                                  </Dropdown.Menu>
                                  :
                                  filter === "declined" ?
                                    <Dropdown.Menu>
                                      <div className="colunm_checkbox">
                                        <ul className="p-0 m-0">
                                          <li>
                                            <label htmlFor="select_all_adcodes">
                                              <input
                                                className={isIndeterminate(colvisDeclined) ? "form-check-input parital_checkbox" : "form-check-input"}
                                                type="checkbox"
                                                id="select_all_adcodes"
                                                checked={Object.values(colvisDeclined).every(value => value === true)}
                                                onChange={(e) => {
                                                  const updatedObj = Object.keys(colvisDeclined).reduce((acc, key) => {
                                                    acc[key] = e.target.checked;
                                                    return acc;
                                                  }, {});
                                                  setColvisDeclined(updatedObj);
                                                }}
                                              />
                                              <span>
                                                < >Select All</>
                                              </span>
                                            </label>
                                          </li>
                                          <hr className="new_item_line_d3" />
                                        </ul>
                                        <ul className="p-0 m-0 colvis_scroll">
                                          <Row>
                                            {filterRepeaterValueOptions_colvisDeclined.map(({ label, value }) => (
                                              <Col span={8}>
                                                <li key={value}>
                                                  <label htmlFor={value}>
                                                    <input
                                                      className="form-check-input"
                                                      type="checkbox"
                                                      id={value}
                                                      checked={colvisDeclined[value]}
                                                      onChange={() => {
                                                        const tempData = { ...colvisDeclined };
                                                        tempData[value] = !tempData[value];
                                                        setColvisDeclined(tempData);
                                                      }}
                                                    />
                                                    <span> {label?.length >= 50 ?
                                                      <Tooltip title={label}>< >{label?.slice(0, 50)}...</></Tooltip> :
                                                      < >{label}</>}
                                                    </span>
                                                  </label>
                                                </li>
                                              </Col>
                                            ))}
                                          </Row>
                                        </ul>
                                      </div>
                                    </Dropdown.Menu>
                                    :
                                    <Dropdown.Menu>
                                      <div className="colunm_checkbox">
                                        <ul className="p-0 m-0"

                                        >
                                          <li
                                          >
                                            <label htmlFor="select_all_adcodes">
                                              <input
                                                className={isIndeterminate(colvisApproved) ? "form-check-input parital_checkbox" : "form-check-input"}
                                                type="checkbox"
                                                id="select_all_adcodes"
                                                checked={Object.values(colvisApproved).every(value => value === true)}
                                                onChange={(e) => {
                                                  const updatedObj = Object.keys(colvisApproved).reduce((acc, key) => {
                                                    acc[key] = e.target.checked;
                                                    return acc;
                                                  }, {});

                                                  setColvisApproved(updatedObj);
                                                }}
                                              />
                                              <span>
                                                < >Select All</>
                                              </span>
                                            </label>
                                          </li>
                                          <hr className="new_item_line_d3" />

                                        </ul>
                                        <ul
                                          className="p-0 m-0 colvis_scroll"
                                        >
                                          <Row >
                                            {filterRepeaterValueOptions_colvisApproved.map(({ label, value }) => (
                                              <Col span={8}>
                                                <li key={value}>
                                                  <label htmlFor={value}>
                                                    <input
                                                      className="form-check-input"
                                                      type="checkbox"
                                                      id={value}
                                                      checked={colvisApproved[value]}
                                                      onChange={() => {
                                                        const tempData = { ...colvisApproved };
                                                        tempData[value] = !tempData[value];
                                                        setColvisApproved(tempData);
                                                      }}
                                                    />
                                                    <span> {label?.length >= 50 ?
                                                      <Tooltip title={label}>< >{label?.slice(0, 50)}...</></Tooltip> :
                                                      < >{label}</>}
                                                    </span>
                                                  </label>
                                                </li>
                                              </Col>
                                            ))}

                                            {/* PIXALATE SUNSET: Pixalate column-visibility header hidden
                                            <hr className="new_item_line_d3" />
                                            <Col span={24}>
                                              <li >
                                                <label >

                                                  <h5> Pixalate
                                                  </h5>
                                                </label>
                                              </li>
                                            </Col>
                                            */}


                                          </Row>

                                          <Row >
                                            {/* PIXALATE SUNSET: Pixalate metric column-visibility checkboxes hidden
                                            {filterRepeaterValueOptions_colvis2.map(({ label, value }) => (
                                              <Col span={8}>
                                                <li key={value}>
                                                  <label htmlFor={value}>
                                                    <input
                                                      className="form-check-input"
                                                      type="checkbox"
                                                      id={value}
                                                      checked={colvisApproved[value]}
                                                      onChange={() => {
                                                        const tempData = { ...colvisApproved };
                                                        tempData[value] = !tempData[value];
                                                        setColvisApproved(tempData);
                                                      }}
                                                    />
                                                    <span> {label?.length >= 50 ?
                                                      <Tooltip title={label}>< >{label?.slice(0, 50)}...</></Tooltip> :
                                                      < >{label}</>}
                                                    </span>
                                                  </label>
                                                </li>
                                              </Col>
                                            ))}
                                            */}

                                            <hr className="new_item_line_d3" />
                                            <Col span={24}>
                                              <li >
                                                <label >

                                                  <h5> Human
                                                  </h5>
                                                </label>
                                              </li>
                                            </Col>
                                            {filterRepeaterValueOptions_colvis3.map(({ label, value }) => (
                                              <Col span={8}>
                                                <li key={value}>
                                                  <label htmlFor={value}>
                                                    <input
                                                      className="form-check-input"
                                                      type="checkbox"
                                                      id={value}
                                                      checked={colvisApproved[value]}
                                                      onChange={() => {
                                                        const tempData = { ...colvisApproved };
                                                        tempData[value] = !tempData[value];
                                                        setColvisApproved(tempData);
                                                      }}
                                                    />
                                                    <span> {label?.length >= 50 ?
                                                      <Tooltip title={label}>< >{label?.slice(0, 50)}...</></Tooltip> :
                                                      < >{label}</>}
                                                    </span>
                                                  </label>
                                                </li>
                                              </Col>
                                            ))}


                                          </Row>

                                          <Row >
                                            <hr className="new_item_line_d3" />
                                            <Col span={24}>
                                              <li >
                                                <label >

                                                  <h5> Double Verify
                                                  </h5>
                                                </label>
                                              </li>
                                            </Col>
                                            {filterRepeaterValueOptions_colvis4.map(({ label, value }) => (
                                              <Col span={8}>
                                                <li key={value}>
                                                  <label htmlFor={value}>
                                                    <input
                                                      className="form-check-input"
                                                      type="checkbox"
                                                      id={value}
                                                      checked={colvisApproved[value]}
                                                      onChange={() => {
                                                        const tempData = { ...colvisApproved };
                                                        tempData[value] = !tempData[value];
                                                        setColvisApproved(tempData);
                                                      }}
                                                    />
                                                    <span> {label?.length >= 50 ?
                                                      <Tooltip title={label}>< >{label?.slice(0, 50)}...</></Tooltip> :
                                                      < >{label}</>}
                                                    </span>
                                                  </label>
                                                </li>
                                              </Col>
                                            ))}


                                          </Row>

                                        </ul>
                                      </div>

                                    </Dropdown.Menu>
                        }

                      </Dropdown>
                    </div>
                  </div>
                }
              </div>
            </div>

            <div className="table_content--box --new_layout_table_design no_data_screen_view user_sync_table_v2 ">
              {loading && !initialLoad &&
                <div className="table_new_loader_d2">
                  <img src={FullLoader} className="img-fluid" alt="" />
                </div>
              }
              {initialLoad || tabLoad ?
                <TableLoader />
                :
                <>
                  {filter === "all" ?
                    <Table
                      columns={columnsAll}
                      tableLayout="fixed"
                      pageSize={100}
                      dataSource={data}
                      onChange={handleTableChange}
                      // loading={loading}
                      locale={locale}
                      // components={components}
                      pagination={false}
                      rowKey={(record) => record.id}
                      showSorterTooltip={false}
                      // loadingIndicator={<img src={FullLoader} alt="" />}
                      scroll={{ x: data.length === 0 ? '1500' : 'max-content', y: 'calc(100vh - 36.9rem' }} />

                    : filter === "new" ?
                      <Table
                        columns={columnsNew}
                        tableLayout="fixed"
                        pageSize={100}
                        dataSource={data}
                        onChange={handleTableChange}
                        showSorterTooltip={false}
                        // loading={loading}
                        locale={locale}
                        // components={components}
                        pagination={false}
                        rowKey={(record) => record.id}
                        scroll={{ x: data.length === 0 ? '1500' : 'max-content', y: 'calc(100vh - 36.3rem' }} />

                      : filter === "onboard" ?
                        <Table
                          columns={columnsOnboard}
                          tableLayout="fixed"
                          // tableLayout={data.length === 0 ? 'auto' : 'fixed'}
                          pageSize={100}
                          dataSource={data}
                          onChange={handleTableChange}
                          showSorterTooltip={false}
                          // loading={loading}
                          locale={locale}
                          // components={components}
                          pagination={false}
                          rowKey={(record) => record.id}
                          scroll={{ x: data.length === 0 ? 1500 : 'max-content', y: 'calc(100vh - 36.3rem' }} />

                        : filter === "rejected" ?
                          <Table
                            columns={columnsRejected}
                            tableLayout="fixed"
                            // tableLayout={data.length === 0 ? 'auto' : 'fixed'}
                            pageSize={100}
                            dataSource={data}
                            onChange={handleTableChange}
                            showSorterTooltip={false}
                            // loading={loading}
                            locale={locale}
                            // components={components}
                            pagination={false}
                            rowKey={(record) => record.id}
                            scroll={{ x: data.length === 0 ? 1500 : 'max-content', y: 'calc(100vh - 36.3rem' }} />
                          :
                          filter === "archived" ?
                            <Table
                              columns={columnsArchive}
                              tableLayout="fixed"
                              pageSize={100}
                              dataSource={data}
                              onChange={handleTableChange}
                              showSorterTooltip={false}
                              locale={locale}
                              pagination={false}
                              rowKey={(record) => record.id}
                              scroll={{ x: data.length === 0 ? '1500' : 'max-content', y: 'calc(100vh - 36.3rem' }} />
                            :
                            filter === "declined" ?
                              <Table
                                columns={columnsDeclined}
                                tableLayout="fixed"
                                pageSize={100}
                                dataSource={data}
                                onChange={handleTableChange}
                                showSorterTooltip={false}
                                locale={locale}
                                pagination={false}
                                rowKey={(record) => record.id}
                                scroll={{ x: data.length === 0 ? '1500' : 'max-content', y: 'calc(100vh - 36.3rem' }} />
                              :
                              <Table
                                columns={columnsApproved}
                                tableLayout="fixed"
                                pageSize={100}
                                dataSource={data}
                                onChange={handleTableChange}
                                showSorterTooltip={false}
                                // loading={loading}
                                locale={locale}
                                // components={components}
                                pagination={false}
                                rowKey={(record) => record.id}
                                scroll={{ x: data.length === 0 ? '1500' : 'max-content', y: 'calc(100vh - 39.3rem' }} />
                  }
                </>
              }

              {data.length > 0 && !tabLoad &&
                <Row className="custom_pagination--container">
                  <Col span={6}>
                    <div className="form_content_block--group mb_0">
                      <Select
                        className='form_select basic sm no_search'
                        value={page.pageSize}
                        onChange={handlePageSizeChange}
                        style={{ width: 80 }}
                        showSearch={false}
                        options={[
                          { value: 10, label: 10 },
                          { value: 20, label: 20 },
                          { value: 50, label: 50 },
                          { value: 100, label: 100 },
                        ]} />
                      <label className='custom_pagination--label'>
                        items per page
                      </label>
                    </div>
                  </Col>
                  <Col span={6}>
                    <span className="custom_pagination--total-text">
                      {`${(page.current - 1) * page.pageSize + 1}-${Math.min(page.current * page.pageSize, page.total)} of ${page.total} items`}
                    </span>
                  </Col>
                  <Col span={6}>
                    <Pagination
                      current={page.current}  // Pass individual props instead of spreading them
                      pageSize={page.pageSize}
                      total={page.total}
                      onChange={handlePageChange}
                      showSizeChanger={false}
                      itemRender={itemRender}
                      className="custom_pagination" />
                  </Col>
                </Row>
              }
            </div>
          </div>
        </div>

      </div>

      <div
      // style={{ opacity: pageView === "import" ? 1 : 0, display: pageView === "import" ? "block" : "none" }}
      >
        {pageView === "import" &&
          <PublisherImport handlePageViewChange={handlePageView} />
        }
        {pageView === "view" &&
          <MyProfileV2 callFrom="listing" id={publisherViewId} handlePageViewChange={handlePageViewForEdit} publisherViewName={publisherViewName} />
          // <PublisherViewEdit handlePageViewChange={handlePageViewForEdit} id={publisherViewId} accountStatus={accountStatus} publisherViewName={publisherViewName} />
        }
      </div>

      <Modal
        title={
          <div className='custom_modal--header'>
            <div className="d_flex justify_content_between">
              <h3 className='heading' >
                <img src={SureIcon} alt='USP' /> Are you sure?
              </h3>
            </div>
          </div>
        }
        centered
        footer={false}
        maskClosable={false}
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={archiveModalOpen}
        width={700}
        className='custom_modal custom_modal_form_d2'
        onCancel={() => {
          setArchiveModalOpen(false);
          setArchivePendingRecord(null);
        }}
      >
        <div className="custom_modal--body p-0">
          <div className="tab_content--body border-0" style={{ padding: '2.4rem' }}>
            <div className="container_box--form-container p-0 border-0 mb-0">
              <Row gutter={16}>
                <Col span={24}>
                  <p className="modal_text_para">
                    Are you sure you want to <span className="text">“Archive”</span> this publisher? All associated zones (<span className="number">{archivePendingRecord?.record.zone}</span>) under this publisher will also be archived. Please review and confirm.
                  </p>
                </Col>
              </Row>
            </div>
          </div>
          <div className='two_modal_btn'>
            <div className="btn_group justify-content-end gap_8">
              <button className="w_120_d2 btn btn_white_outline w_fit_content"
                onClick={() => {
                  setArchiveModalOpen(false);
                  setArchivePendingRecord(null);
                }}
              >Cancel</button>
              <button className="w_120_d2 btn btn_primary w_fit_content"
                onClick={() => {
                  setArchiveModalOpen(false);
                  const { event, record } = archivePendingRecord;
                  setArchivePendingRecord(null);
                  let token = Cookies.get("token_xapads_ssp");
                  if (!token) return;
                  let payload = {
                    "status": event,
                    "_id": record?._id,
                    "approvedOnce": record?.approvedOnce
                  };
                  setLoading(true);
                  axios
                    .post(configData.SERVER_URL + `ops/statusUpdate`, payload, {
                      headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                      },
                    })
                    .then((response) => {
                      setApicall(!apiCall);
                      notifysuccess(response.data.message);
                    })
                    .catch((error) => {
                      if (error.response.data.message?.length !== 0) {
                        notifyfailure(error.response.data.message);
                      } else {
                        notifycatch();
                      }
                      setLoading(false);
                    });
                }}
              >Yes, Archive</button>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        title={
          <div className="custom_modal--header">
            <div className="d_flex justify_content_between">
              <h3 className="heading">
                <img src={SureIcon} alt="USP" /> Are you sure?
              </h3>
            </div>
          </div>
        }
        centered
        footer={false}
        maskClosable={false}
        open={isCheckinUserVisible}
        width={650}
        className="custom_modal custom_modal_form_d2"
        onCancel={() => {
          setIsCheckinUserVisible(false);
          setCheckinUser(null);
          setIsCheckinUserLoader(false)
        }}
      >
        <div className="custom_modal--body p-0">

          <div className="tab_content--body border-0 p-4">
            <Row gutter={16}>
              <Col span={24}>
                {checkinUser && (
                  <p className="modal_text_para">
                    Are you sure you want to <span style={{ color: "#020617" }}>“Check-in”</span> this publisher <span style={{ color: '#187B80' }}>
                      {checkinUser?.Name || ""} ({checkinUser?.Email || ""}
                    </span>)? This will log you out from all open tabs and check in the publisher account.
                  </p>
                )}
              </Col>
            </Row>
          </div>

          <div className="two_modal_btn">
            <div className="btn_group justify-content-end gap_8">

              <button
                className="w_120_d2 btn btn_white_outline w_fit_content"
                onClick={() => {
                  setIsCheckinUserVisible(false);
                  setCheckinUser(null);
                  setIsCheckinUserLoader(false)
                }}
              >
                Cancel
              </button>

              <button className="w_120_d2 btn btn_primary w_fit_content"
                onClick={() => { handleCheckIn(checkinUser) }}
              >
                Confirm
              </button>

            </div>
          </div>

        </div>
      </Modal>


    </>
  );
};

export default PublisherListing;
